"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2256],{

/***/ 23415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_DatePicker; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Trigger/index.js + 2 modules
var Trigger = __webpack_require__(12830);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/keycode.js
var keycode = __webpack_require__(85660);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconClose/index.js
var IconClose = __webpack_require__(59547);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_class/icon-hover.js
var icon_hover = __webpack_require__(25227);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_class/picker/input.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};








function DateInput(_a, ref) {
    var _b, _c;
    var style = _a.style, className = _a.className, propPrefixCls = _a.prefixCls, allowClear = _a.allowClear, status = _a.status, error = _a.error, disabled = _a.disabled, placeholder = _a.placeholder, format = _a.format, propSize = _a.size, onClear = _a.onClear, editable = _a.editable, value = _a.value, inputValue = _a.inputValue, onPressEnter = _a.onPressEnter, suffixIcon = _a.suffixIcon, prefix = _a.prefix, onChange = _a.onChange, popupVisible = _a.popupVisible, isPlaceholder = _a.isPlaceholder, rest = __rest(_a, ["style", "className", "prefixCls", "allowClear", "status", "error", "disabled", "placeholder", "format", "size", "onClear", "editable", "value", "inputValue", "onPressEnter", "suffixIcon", "prefix", "onChange", "popupVisible", "isPlaceholder"]);
    var _d = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _d.getPrefixCls, ctxSize = _d.size, locale = _d.locale, rtl = _d.rtl;
    var input = (0,react.useRef)(null);
    var size = propSize || ctxSize;
    (0,react.useImperativeHandle)(ref, function () { return ({
        focus: function () {
            input.current && input.current.focus && input.current.focus();
        },
        blur: function () {
            input.current && input.current.blur && input.current.blur();
        },
    }); });
    function onKeyDown(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === keycode/* Enter.code */.Ce.code) {
            onPressEnter && onPressEnter();
        }
    }
    var showValue = '';
    if (inputValue !== undefined) {
        showValue = inputValue;
    }
    else if (value && !(0,is/* isArray */.kJ)(value)) {
        showValue =
            typeof format === 'function'
                ? format(value)
                : value.locale(locale.dayjsLocale).format(format);
    }
    var readOnlyProps = editable ? {} : { readOnly: true };
    var prefixCls = propPrefixCls || getPrefixCls('picker');
    var inputStatus = status || (error ? 'error' : undefined);
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-size-" + size, (_b = {},
        _b[prefixCls + "-focused"] = !!popupVisible,
        _b[prefixCls + "-disabled"] = disabled,
        _b[prefixCls + "-has-prefix"] = prefix,
        _b[prefixCls + "-" + inputStatus] = inputStatus,
        _b[prefixCls + "-rtl"] = rtl,
        _b), className);
    return (react.createElement("div", __assign({ style: style, className: classNames }, (0,omit/* default */.Z)(rest, ['onChange', 'onPressEnter'])),
        prefix && react.createElement("div", { className: prefixCls + "-prefix" }, prefix),
        react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-input", (_c = {}, _c[prefixCls + "-input-placeholder"] = isPlaceholder, _c)) },
            react.createElement("input", __assign({ ref: input, disabled: disabled, placeholder: placeholder, className: prefixCls + "-start-time", value: showValue, onKeyDown: onKeyDown, onChange: onChange }, readOnlyProps))),
        react.createElement("div", { className: prefixCls + "-suffix" },
            allowClear && showValue && (react.createElement(icon_hover/* default */.Z, { prefix: prefixCls, onClick: onClear, className: prefixCls + "-clear-icon" },
                react.createElement(IconClose/* default */.Z, null))),
            react.createElement("span", { className: prefixCls + "-suffix-icon" }, suffixIcon))));
}
/* harmony default export */ var input = ((0,react.forwardRef)(DateInput));

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/dayjs.js
var _util_dayjs = __webpack_require__(50381);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCalendar/index.js
var IconCalendar = __webpack_require__(89671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/context.js
var context = __webpack_require__(4245);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCalendarClock/index.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconCalendarClockComponent(iconProps, ref) {
  var _useContext = (0,react.useContext)(context/* IconContext */.P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-calendar-clock")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react.createElement("svg", (0,esm_extends/* default */.Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M7 22h34V10a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h18M34 5v8M14 5v8"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "none",
    d: "M36 44a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm1.5-9.75V29h-3v8.25H42v-3h-4.5Z",
    clipRule: "evenodd"
  }));
}

var IconCalendarClock = /*#__PURE__*/react.forwardRef(IconCalendarClockComponent);
IconCalendarClock.defaultProps = {
  isIcon: true
};
IconCalendarClock.displayName = 'IconCalendarClock';
/* harmony default export */ var react_icon_IconCalendarClock = (IconCalendarClock);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Button/index.js + 1 modules
var Button = __webpack_require__(56187);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/panels/shortcuts.js



function Shortcuts(props, ref) {
    var prefixCls = props.prefixCls, _a = props.shortcuts, shortcuts = _a === void 0 ? [] : _a, onSelectNow = props.onSelectNow, nowText = props.nowText, showNowBtn = props.showNowBtn, showTime = props.showTime, onMouseEnterShortcut = props.onMouseEnterShortcut, onMouseLeaveShortcut = props.onMouseLeaveShortcut;
    function onMouseEnter(shortcut) {
        onMouseEnterShortcut && onMouseEnterShortcut(shortcut);
    }
    function onMouseLeave(shortcut) {
        onMouseLeaveShortcut && onMouseLeaveShortcut(shortcut);
    }
    function onClick(shortcut, e) {
        var onSelectShortcut = props.onSelectShortcut;
        onSelectShortcut && onSelectShortcut(shortcut, e);
    }
    var hasShortcuts = (0,is/* isArray */.kJ)(shortcuts) && shortcuts.length > 0;
    var shouldShowNowBtn = showNowBtn && showTime && !hasShortcuts;
    return (react.createElement("div", { ref: ref, className: prefixCls + "-shortcuts" },
        shouldShowNowBtn && (react.createElement(Button/* default */.Z, { size: "mini", onClick: onSelectNow }, nowText)),
        hasShortcuts &&
            shortcuts.map(function (shortcut, index) {
                return (react.createElement(Button/* default */.Z, { key: index, size: "mini", onMouseEnter: function () { return onMouseEnter(shortcut); }, onMouseLeave: function () { return onMouseLeave(shortcut); }, onClick: function (e) { return onClick(shortcut, e); } }, shortcut.text));
            })));
}
/* harmony default export */ var panels_shortcuts = ((0,react.forwardRef)(Shortcuts));

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Link/index.js
var Link = __webpack_require__(12106);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/panels/footer.js





function Footer(props) {
    var showTime = props.showTime, prefixCls = props.prefixCls, DATEPICKER_LOCALE = props.DATEPICKER_LOCALE, disabled = props.disabled, onClickConfirmBtn = props.onClickConfirmBtn, onClickSelectTimeBtn = props.onClickSelectTimeBtn, isTimePanel = props.isTimePanel, onSelectNow = props.onSelectNow, showNowBtn = props.showNowBtn, shortcuts = props.shortcuts, onMouseEnterShortcut = props.onMouseEnterShortcut, onMouseLeaveShortcut = props.onMouseLeaveShortcut, onSelectShortcut = props.onSelectShortcut, extra = props.extra, mode = props.mode, shortcutsPlacementLeft = props.shortcutsPlacementLeft;
    var hasShortcuts = (0,is/* isArray */.kJ)(shortcuts) && shortcuts.length > 0;
    var shouldShowNowBtn = showNowBtn && showTime && !hasShortcuts;
    var shouldShouldShortcuts = shouldShowNowBtn || (hasShortcuts && !shortcutsPlacementLeft);
    return (react.createElement("div", { className: prefixCls + "-footer" },
        extra && react.createElement("div", { className: prefixCls + "-footer-extra-wrapper" }, extra),
        !showTime && showNowBtn && mode === 'date' && (react.createElement("div", { className: prefixCls + "-footer-now-wrapper" },
            react.createElement(Link/* default */.Z, { onClick: onSelectNow }, DATEPICKER_LOCALE.today))),
        shouldShouldShortcuts || showTime ? (react.createElement("div", { className: prefixCls + "-footer-btn-wrapper" },
            !shortcutsPlacementLeft ? (react.createElement(panels_shortcuts, { shortcuts: shortcuts, prefixCls: prefixCls, onSelectNow: onSelectNow, nowText: DATEPICKER_LOCALE.now, showNowBtn: showNowBtn, onMouseEnterShortcut: onMouseEnterShortcut, onMouseLeaveShortcut: onMouseLeaveShortcut, onSelectShortcut: onSelectShortcut, showTime: showTime })) : (react.createElement("div", null)),
            showTime && (react.createElement(react.Fragment, null,
                react.createElement(Button/* default */.Z, { type: "text", size: "mini", onClick: onClickSelectTimeBtn, className: isTimePanel ? prefixCls + "-btn-select-date" : prefixCls + "-btn-select-time" }, isTimePanel ? DATEPICKER_LOCALE.selectDate : DATEPICKER_LOCALE.selectTime),
                react.createElement(Button/* default */.Z, { className: prefixCls + "-btn-confirm", type: "primary", size: "mini", disabled: disabled, onClick: onClickConfirmBtn }, DATEPICKER_LOCALE.ok))))) : null));
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/context.js

/* harmony default export */ var DatePicker_context = ((0,react.createContext)({}));

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/usePrevious.js
var usePrevious = __webpack_require__(69882);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useUpdate.js
var useUpdate = __webpack_require__(1083);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/util.js



function getFormat(time) {
    return isDayjs(time) && time.format('HH:mm:ss');
}
function isTimeArrayChange(prevTime, nextTime) {
    return (getFormat(prevTime[0]) !== getFormat(nextTime[0]) ||
        getFormat(prevTime[1]) !== getFormat(nextTime[1]));
}
function getAvailableDayjsLength(value) {
    if (!value) {
        return 0;
    }
    if ((0,is/* isArray */.kJ)(value)) {
        if ((0,is/* isDayjs */.qE)(value[0]) && (0,is/* isDayjs */.qE)(value[1])) {
            return 2;
        }
        if (!(0,is/* isDayjs */.qE)(value[0]) && !(0,is/* isDayjs */.qE)(value[1])) {
            return 0;
        }
        return 1;
    }
    return 0;
}
// https://github.com/react-component/picker/blob/master/src/utils/dateUtil.ts#L234
function isDisabledDate(cellDate, disabledDate, mode) {
    if (typeof disabledDate !== 'function') {
        return false;
    }
    // Whether cellDate is disabled in range
    var getDisabledFromRange = function (currentMode, start, end) {
        var current = start;
        while (current <= end) {
            var date = void 0;
            switch (currentMode) {
                case 'date': {
                    date = _util_dayjs/* methods.set */.xB.set(cellDate, 'date', current);
                    if (!disabledDate(date)) {
                        return false;
                    }
                    break;
                }
                case 'month': {
                    date = _util_dayjs/* methods.set */.xB.set(cellDate, 'month', current);
                    if (!isDisabledDate(date, disabledDate, 'month')) {
                        return false;
                    }
                    break;
                }
                case 'year': {
                    date = _util_dayjs/* methods.set */.xB.set(cellDate, 'year', current);
                    if (!isDisabledDate(date, disabledDate, 'year')) {
                        return false;
                    }
                    break;
                }
                default:
                    break;
            }
            current += 1;
        }
        return true;
    };
    switch (mode) {
        case 'date':
        case 'week': {
            return disabledDate(cellDate);
        }
        case 'month': {
            var startDate = 1;
            var endDate = cellDate.endOf('month').get('date');
            return getDisabledFromRange('date', startDate, endDate);
        }
        case 'quarter': {
            var startMonth = Math.floor(cellDate.get('month') / 3) * 3;
            var endMonth = startMonth + 2;
            return getDisabledFromRange('month', startMonth, endMonth);
        }
        case 'year': {
            return getDisabledFromRange('month', 0, 11);
        }
        default:
            return false;
    }
}
function getDefaultWeekStart(dayjsLocale) {
    var _a, _b;
    return ((_b = (_a = (dayjs_min_default()).Ls) === null || _a === void 0 ? void 0 : _a[dayjsLocale]) === null || _b === void 0 ? void 0 : _b.weekStart) || 0;
}
function getLocaleDayjsValue(date, dayjsLocale) {
    return date ? date.locale(dayjsLocale) : date;
}
function getFormatByIndex(format, index) {
    return (0,is/* isArray */.kJ)(format) ? format[index] : format;
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/pick.js
var pick = __webpack_require__(9472);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/picker.js
var picker_assign = (undefined && undefined.__assign) || function () {
    picker_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return picker_assign.apply(this, arguments);
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};


















function picker_getFormat(props) {
    var format = props.format, picker = props.picker, showTime = props.showTime;
    var valueFormat;
    var mode = props.mode || picker.props.pickerType;
    switch (mode) {
        case 'date':
            valueFormat = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
            break;
        case 'month':
            valueFormat = 'YYYY-MM';
            break;
        case 'year':
            valueFormat = 'YYYY';
            break;
        case 'week':
            valueFormat = 'gggg-wo';
            break;
        case 'quarter':
            valueFormat = 'YYYY-[Q]Q';
            break;
        default:
            valueFormat = 'YYYY-MM-DD';
    }
    if (format) {
        valueFormat = format;
    }
    return valueFormat;
}
var defaultProps = {
    allowClear: true,
    unmountOnExit: true,
    position: 'bl',
    editable: true,
    showNowBtn: true,
};
var triggerPopupAlign = { bottom: 4 };
var Picker = function (baseProps) {
    var _a = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _a.getPrefixCls, locale = _a.locale, ctxSize = _a.size, componentConfig = _a.componentConfig, rtl = _a.rtl;
    if (rtl) {
        defaultProps.position = 'br';
    }
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.DatePicker);
    var allowClear = props.allowClear, className = props.className, style = props.style, placeholder = props.placeholder, getPopupContainer = props.getPopupContainer, disabled = props.disabled, position = props.position, error = props.error, status = props.status, unmountOnExit = props.unmountOnExit, editable = props.editable, triggerProps = props.triggerProps, picker = props.picker, shortcuts = props.shortcuts, onSelect = props.onSelect, onVisibleChange = props.onVisibleChange, propsValue = props.value, onChange = props.onChange, icons = props.icons, disabledDate = props.disabledDate, showTime = props.showTime, showNowBtn = props.showNowBtn, onSelectShortcut = props.onSelectShortcut, extra = props.extra, shortcutsPlacementLeft = props.shortcutsPlacementLeft, onOk = props.onOk, defaultPickerValue = props.defaultPickerValue, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, triggerElement = props.triggerElement, utcOffset = props.utcOffset, timezone = props.timezone, panelRender = props.panelRender;
    var prefixCls = getPrefixCls('picker');
    var DATEPICKER_LOCALE = locale.DatePicker;
    var weekStart = (0,is/* isUndefined */.o8)(props.dayStartOfWeek)
        ? getDefaultWeekStart(locale.dayjsLocale)
        : props.dayStartOfWeek;
    // picker.props.pickerType: Compatible with defaultProps
    var mode = props.mode || picker.props.pickerType;
    var refInput = (0,react.useRef)(null);
    var refPanel = (0,react.useRef)(null);
    var refShortcuts = (0,react.useRef)(null);
    var realFormat = picker_getFormat(props);
    var format = realFormat;
    if (typeof format === 'function') {
        format = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
    }
    function getDefaultValue() {
        var value;
        if (props.value) {
            value = (0,_util_dayjs/* getDayjsValue */.p3)(props.value, format, utcOffset, timezone);
        }
        else {
            value = (0,_util_dayjs/* getDayjsValue */.p3)(props.defaultValue, format, utcOffset, timezone);
        }
        return value;
    }
    var _b = __read((0,react.useState)(getDefaultValue()), 2), value = _b[0], setValue = _b[1];
    var _c = __read((0,react.useState)(props.popupVisible), 2), popupVisible = _c[0], setPopupVisible = _c[1];
    var _d = __read((0,react.useState)(false), 2), isTimePanel = _d[0], setIsTimePanel = _d[1];
    var _e = __read((0,react.useState)(), 2), hoverPlaceholderValue = _e[0], setHoverPlaceholderValue = _e[1];
    var mergedPopupVisible = 'popupVisible' in props ? props.popupVisible : popupVisible;
    var mergedValue = 'value' in props ? (0,_util_dayjs/* getDayjsValue */.p3)(propsValue, format, utcOffset, timezone) : value;
    var defaultPageShowDate = mergedValue || (0,_util_dayjs/* getDayjsValue */.p3)(defaultPickerValue, format) || (0,_util_dayjs/* getNow */.Iz)();
    var _f = __read((0,react.useState)(), 2), inputValue = _f[0], setInputValue = _f[1];
    var _g = __read((0,react.useState)(), 2), valueShow = _g[0], setValueShow = _g[1];
    var _h = __read((0,react.useState)(), 2), shortcutValue = _h[0], setShortcutValue = _h[1];
    var _j = __read((0,react.useState)(defaultPageShowDate), 2), pageShowDate = _j[0], setPageShowDate = _j[1];
    var mergedPageShowDate = (0,_util_dayjs/* getDayjsValue */.p3)(pickerValue, format) || pageShowDate;
    var panelValue = shortcutValue || valueShow || mergedValue;
    var _k = __read((0,react.useState)(mode), 2), panelMode = _k[0], setPanelMode = _k[1];
    var defaultTimeValue = ((0,is/* isObject */.Kn)(showTime) &&
        (0,_util_dayjs/* getDayjsValue */.p3)(showTime.defaultValue, showTime.format || 'HH:mm:ss')) ||
        (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone);
    var timeValue = panelValue || defaultTimeValue;
    function focusInput() {
        refInput.current && refInput.current.blur && refInput.current.focus();
    }
    function blurInput() {
        refInput.current && refInput.current.blur && refInput.current.blur();
    }
    var previousUtcOffset = (0,usePrevious/* default */.Z)(utcOffset);
    var previousTimezone = (0,usePrevious/* default */.Z)(timezone);
    // when timezone or utcOffset change changed
    (0,useUpdate/* default */.Z)(function () {
        if (value && (previousUtcOffset !== utcOffset || timezone !== previousTimezone)) {
            var localValue = (0,_util_dayjs/* toLocal */.sB)(value, previousUtcOffset, previousTimezone);
            setValue((0,_util_dayjs/* toTimezone */.xp)(localValue, utcOffset, timezone));
        }
    }, [utcOffset, previousUtcOffset, timezone, previousTimezone]);
    (0,react.useEffect)(function () {
        setInputValue(undefined);
        setHoverPlaceholderValue(undefined);
        if (mergedPopupVisible) {
            setPageShowDate(defaultPageShowDate);
            if (shortcutsPlacementLeft) {
                refShortcuts.current.style.maxHeight = refPanel.current.clientHeight + "px";
            }
        }
        else {
            setValueShow(undefined);
            setShortcutValue(undefined);
            setTimeout(function () {
                setIsTimePanel(false);
                setPanelMode(mode);
                blurInput();
            }, 100);
        }
    }, [mergedPopupVisible]);
    function visibleChange(visible) {
        if (visible) {
            setOpen(visible, function () {
                focusInput();
            });
        }
        else {
            setOpen(false);
        }
    }
    function handlePickerValueChange(v) {
        onPickerValueChange && onPickerValueChange(v.format(format), v);
    }
    function setOpen(visible, callback) {
        setPopupVisible(visible);
        onVisibleChange && onVisibleChange(visible);
        callback && callback();
    }
    function onClear(e) {
        e.stopPropagation();
        setValue(undefined);
        setValueShow(undefined);
        onHandleChange(undefined);
        props.onClear && props.onClear();
    }
    function onClickConfirmBtn() {
        var pv = getLocaleDayjsValue(panelValue, locale.dayjsLocale);
        onConfirmValue();
        onOk && onOk(pv && pv.format(format), pv);
    }
    function onConfirmValue() {
        setValue(panelValue);
        onHandleChange(panelValue);
        setOpen(false);
    }
    function onHandleSelect(_, date, now) {
        setInputValue(undefined);
        setHoverPlaceholderValue(undefined);
        if (showTime) {
            var newTime = now ? date : (0,_util_dayjs/* getValueWithTime */.zr)(date, timeValue);
            setValueShow(newTime);
            setPageShowDate(newTime);
            var localTime = getLocaleDayjsValue((0,_util_dayjs/* toLocal */.sB)(newTime, utcOffset, timezone), locale.dayjsLocale);
            onSelect && onSelect(localTime.format(format), localTime);
        }
        else {
            var localTime = getLocaleDayjsValue((0,_util_dayjs/* toLocal */.sB)(date, utcOffset, timezone).locale(locale.dayjsLocale), locale.dayjsLocale);
            onSelect && onSelect(localTime ? localTime.format(format) : undefined, localTime);
            setValue(date);
            onHandleChange(date);
            setOpen(false);
        }
    }
    function onHandleChange(newValue) {
        if ((0,_util_dayjs/* isDayjsChange */.y2)(newValue, mergedValue)) {
            var localValue = getLocaleDayjsValue((0,_util_dayjs/* toLocal */.sB)(newValue, utcOffset, timezone), locale.dayjsLocale);
            onChange && onChange(localValue ? localValue.format(format) : undefined, localValue);
        }
    }
    function onTimePickerSelect(_, time) {
        var _valueShow = panelValue || (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone);
        var newValueShow = (0,_util_dayjs/* getValueWithTime */.zr)(_valueShow, time);
        setValueShow(newValueShow);
        var localNewValueShow = getLocaleDayjsValue((0,_util_dayjs/* toLocal */.sB)(newValueShow, utcOffset, timezone), locale.dayjsLocale);
        onSelect && onSelect(localNewValueShow.format(format), localNewValueShow);
    }
    function isValid(time) {
        return (typeof time === 'string' &&
            (0,_util_dayjs/* dayjs */.Bv)(time, format).format(format) === time &&
            (typeof disabledDate === 'function' ? !disabledDate((0,_util_dayjs/* dayjs */.Bv)(time, format)) : true));
    }
    function onChangeInput(e) {
        var niv = e.target.value;
        setInputValue(niv);
        if (!mergedPopupVisible) {
            setOpen(true);
        }
        if (isValid(niv)) {
            // https://github.com/arco-design/arco-design/issues/1986
            var newValue = (0,_util_dayjs/* getDayjsValue */.p3)(niv, format);
            setValueShow(newValue);
            setPageShowDate(newValue);
            setInputValue(undefined);
        }
    }
    function onPressEnter() {
        if (panelValue) {
            onConfirmValue();
            blurInput();
        }
        else if (mergedPopupVisible) {
            setOpen(false);
        }
    }
    function changePageShowDate(type, unit, num) {
        if (num === void 0) { num = 1; }
        var newPageShowDate;
        if (type === 'prev') {
            newPageShowDate = _util_dayjs/* methods.subtract */.xB.subtract(mergedPageShowDate, num, unit);
        }
        if (type === 'next') {
            newPageShowDate = _util_dayjs/* methods.add */.xB.add(mergedPageShowDate, num, unit);
        }
        handlePickerValueChange(newPageShowDate);
        setPageShowDate(newPageShowDate);
    }
    function getHeaderOperations(pickMode) {
        if (pickMode === void 0) { pickMode = mode; }
        if (pickMode === 'date' || pickMode === 'week') {
            return {
                onPrev: function () { return changePageShowDate('prev', 'month'); },
                onNext: function () { return changePageShowDate('next', 'month'); },
                onSuperPrev: function () { return changePageShowDate('prev', 'year'); },
                onSuperNext: function () { return changePageShowDate('next', 'year'); },
            };
        }
        if (pickMode === 'month' || pickMode === 'quarter') {
            return {
                onSuperPrev: function () { return changePageShowDate('prev', 'year'); },
                onSuperNext: function () { return changePageShowDate('next', 'year'); },
            };
        }
        if (pickMode === 'year') {
            return {
                onSuperPrev: function () { return changePageShowDate('prev', 'year', 10); },
                onSuperNext: function () { return changePageShowDate('next', 'year', 10); },
            };
        }
    }
    function onSelectNow() {
        var now = getLocaleDayjsValue((0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone), locale.dayjsLocale);
        handlePickerValueChange(now);
        onHandleSelect(now.format(format), now, true);
    }
    function onMouseEnterCell(value, disabled) {
        if (!disabled) {
            var placeHolderValue = showTime ? (0,_util_dayjs/* getValueWithTime */.zr)(value, timeValue) : value;
            setHoverPlaceholderValue(typeof realFormat === 'function'
                ? realFormat(value)
                : placeHolderValue.locale(locale.dayjsLocale).format(format));
        }
    }
    function onMouseLeaveCell() {
        setHoverPlaceholderValue(undefined);
    }
    function onMouseEnterShortcut(shortcut) {
        if (typeof shortcut.value === 'function' && (0,is/* isDayjs */.qE)(shortcut.value())) {
            var sv = (0,_util_dayjs/* getDayjsValue */.p3)(shortcut.value(), format, utcOffset, timezone);
            setPageShowDate(sv);
            handlePickerValueChange(sv);
            setShortcutValue(sv);
        }
    }
    function onMouseLeaveShortcut() {
        var newValue = valueShow || mergedValue || (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone);
        setShortcutValue(undefined);
        setPageShowDate(newValue);
        handlePickerValueChange(newValue);
    }
    function onHandleSelectShortcut(shortcut) {
        onSelectShortcut && onSelectShortcut(shortcut);
        if (typeof shortcut.value === 'function' && (0,is/* isDayjs */.qE)(shortcut.value())) {
            var time = (0,_util_dayjs/* getDayjsValue */.p3)(shortcut.value(), format, utcOffset, timezone);
            setValue(time);
            onHandleChange(time);
            setOpen(false);
        }
    }
    function onClickSelectTimeBtn() {
        setIsTimePanel(!isTimePanel);
    }
    function renderPopup(panelOnly) {
        var _a;
        var classNames = (0,_util_classNames/* default */.Z)(prefixCls + "-container", (_a = {},
            _a[prefixCls + "-panel-only"] = panelOnly,
            _a[prefixCls + "-container-shortcuts-placement-left"] = (0,is/* isArray */.kJ)(shortcuts) && shortcutsPlacementLeft,
            _a[prefixCls + "-container-rtl"] = rtl,
            _a), panelOnly ? className : '');
        var shortcutsProps = {
            prefixCls: prefixCls,
            showTime: showTime,
            shortcuts: shortcuts,
            onSelectNow: onSelectNow,
            showNowBtn: showNowBtn,
            onMouseEnterShortcut: onMouseEnterShortcut,
            onMouseLeaveShortcut: onMouseLeaveShortcut,
            onSelectShortcut: onHandleSelectShortcut,
        };
        var shouldShowFooter = (showTime && panelMode === 'date') ||
            extra ||
            ((0,is/* isArray */.kJ)(shortcuts) && shortcuts.length && !shortcutsPlacementLeft) ||
            (!showTime && panelMode === 'date' && showNowBtn);
        var content = (react.createElement(react.Fragment, null,
            react.cloneElement(picker, picker_assign(picker_assign(picker_assign({}, (0,omit/* default */.Z)(props, ['style'])), getHeaderOperations()), { getHeaderOperations: getHeaderOperations, onSelect: onHandleSelect, onTimePickerSelect: onTimePickerSelect, onSelectNow: onSelectNow, popupVisible: mergedPopupVisible, format: format, value: panelValue, pageShowDate: mergedPageShowDate, localeName: locale.dayjsLocale, setPageShowDate: function (v) {
                    setPageShowDate(v);
                    handlePickerValueChange(v);
                }, timeValue: timeValue, isTimePanel: isTimePanel, panelMode: panelMode, setPanelMode: setPanelMode, onMouseEnterCell: onMouseEnterCell, onMouseLeaveCell: onMouseLeaveCell })),
            !!shouldShowFooter && (react.createElement(Footer, picker_assign({}, shortcutsProps, { DATEPICKER_LOCALE: DATEPICKER_LOCALE, disabled: !panelValue, onClickConfirmBtn: onClickConfirmBtn, extra: extra, mode: panelMode, shortcutsPlacementLeft: shortcutsPlacementLeft, onClickSelectTimeBtn: onClickSelectTimeBtn, isTimePanel: isTimePanel })))));
        var contentWithShortcuts = shortcutsPlacementLeft ? (react.createElement(react.Fragment, null,
            react.createElement(panels_shortcuts, picker_assign({ ref: refShortcuts }, shortcutsProps)),
            react.createElement("div", { ref: refPanel, className: prefixCls + "-panel-wrapper" }, content))) : (content);
        var panelNode = typeof panelRender === 'function' ? panelRender(contentWithShortcuts) : contentWithShortcuts;
        return (react.createElement("div", { className: classNames, onClick: function () {
                refInput.current && refInput.current.focus && refInput.current.focus();
            }, style: panelOnly ? style : {} }, panelNode));
    }
    var size = props.size || ctxSize;
    var suffixIcon = icons && icons.inputSuffix === null
        ? null
        : (icons && icons.inputSuffix) || (showTime ? react.createElement(react_icon_IconCalendarClock, null) : react.createElement(IconCalendar/* default */.Z, null));
    var baseInputProps = {
        style: style,
        className: className,
        popupVisible: mergedPopupVisible,
        format: realFormat,
        disabled: disabled,
        error: error,
        status: status,
        size: size,
        onPressEnter: onPressEnter,
        onClear: onClear,
        prefix: props.prefix,
        suffixIcon: suffixIcon,
        editable: editable && typeof realFormat !== 'function',
        allowClear: allowClear,
    };
    return (react.createElement(DatePicker_context.Provider, { value: { utcOffset: utcOffset, timezone: timezone, weekStart: weekStart } }, triggerElement === null ? (renderPopup(true)) : (react.createElement(Trigger/* default */.Z, picker_assign({ popup: renderPopup, trigger: "click", clickToClose: false, position: position, disabled: disabled, popupAlign: triggerPopupAlign, getPopupContainer: getPopupContainer, onVisibleChange: visibleChange, popupVisible: mergedPopupVisible, classNames: "slideDynamicOrigin", unmountOnExit: unmountOnExit }, triggerProps), triggerElement || (react.createElement(input, picker_assign({}, (0,pick/* pickDataAttributes */.m)(props), baseInputProps, { ref: refInput, placeholder: placeholder || DATEPICKER_LOCALE.placeholder[mode], popupVisible: mergedPopupVisible, value: valueShow || mergedValue, inputValue: hoverPlaceholderValue || inputValue, prefixCls: prefixCls, onChange: onChangeInput, isPlaceholder: !!hoverPlaceholderValue })))))));
};
/* harmony default export */ var DatePicker_picker = (Picker);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_class/picker/input-range.js
var input_range_assign = (undefined && undefined.__assign) || function () {
    input_range_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return input_range_assign.apply(this, arguments);
};
var input_range_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};








function input_range_DateInput(_a, ref) {
    var _b;
    var allowClear = _a.allowClear, error = _a.error, status = _a.status, style = _a.style, className = _a.className, disabled = _a.disabled, _c = _a.placeholder, placeholder = _c === void 0 ? [] : _c, _d = _a.value, value = _d === void 0 ? [] : _d, popupVisible = _a.popupVisible, format = _a.format, propSize = _a.size, onClear = _a.onClear, editable = _a.editable, inputValue = _a.inputValue, onPressEnter = _a.onPressEnter, onPressTab = _a.onPressTab, onChange = _a.onChange, separator = _a.separator, suffixIcon = _a.suffixIcon, changeFocusedInputIndex = _a.changeFocusedInputIndex, focusedInputIndex = _a.focusedInputIndex, isPlaceholder = _a.isPlaceholder, prefix = _a.prefix, rest = input_range_rest(_a, ["allowClear", "error", "status", "style", "className", "disabled", "placeholder", "value", "popupVisible", "format", "size", "onClear", "editable", "inputValue", "onPressEnter", "onPressTab", "onChange", "separator", "suffixIcon", "changeFocusedInputIndex", "focusedInputIndex", "isPlaceholder", "prefix"]);
    var _e = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _e.getPrefixCls, ctxSize = _e.size, locale = _e.locale, rtl = _e.rtl;
    var input0 = (0,react.useRef)(null);
    var input1 = (0,react.useRef)(null);
    var disabled1 = (0,is/* isArray */.kJ)(disabled) ? disabled[0] : disabled;
    var disabled2 = (0,is/* isArray */.kJ)(disabled) ? disabled[1] : disabled;
    (0,react.useImperativeHandle)(ref, function () { return ({
        focus: function (index) {
            var focusedIndex = typeof index === 'number' ? index : focusedInputIndex;
            var focusElement = focusedIndex === 0 ? input0 : input1;
            if ((focusedInputIndex === 0 && !disabled1) || (focusedInputIndex === 1 && !disabled2)) {
                focusElement.current && focusElement.current.focus && focusElement.current.focus();
            }
        },
        blur: function () {
            if (focusedInputIndex === 0) {
                input0.current && input0.current.blur && input0.current.blur();
            }
            if (focusedInputIndex === 1) {
                input1.current && input1.current.blur && input1.current.blur();
            }
        },
    }); });
    function changeFocusedInput(index) {
        if (focusedInputIndex !== index) {
            changeFocusedInputIndex(index);
        }
    }
    function onKeyDown(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === keycode/* Enter.code */.Ce.code) {
            onPressEnter && onPressEnter();
        }
        if (keyCode === keycode/* Tab.code */.OK.code) {
            e.preventDefault();
            onPressTab && onPressTab(e);
        }
    }
    function onChangeInput(e) {
        e.stopPropagation();
        onChange && onChange(e);
    }
    var prefixCls = getPrefixCls('picker');
    var size = propSize || ctxSize;
    var inputStatus = status || (error ? 'error' : undefined);
    var inputClassNames = (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-range", prefixCls + "-size-" + size, (_b = {},
        _b[prefixCls + "-focused"] = !!popupVisible,
        _b[prefixCls + "-disabled"] = disabled1 && disabled2,
        _b[prefixCls + "-" + inputStatus] = inputStatus,
        _b[prefixCls + "-rtl"] = rtl,
        _b[prefixCls + "-has-prefix"] = prefix,
        _b), className);
    var getInputValue = function (index) {
        var valueText = value[index]
            ? value[index].locale(locale.dayjsLocale).format((0,is/* isArray */.kJ)(format) ? format[index] : format)
            : '';
        if (inputValue) {
            return index === focusedInputIndex ? inputValue : valueText;
        }
        return valueText;
    };
    var readOnlyProps = editable ? {} : { readOnly: true };
    function getFocusInputClassName(index) {
        var _a;
        return (0,_util_classNames/* default */.Z)(prefixCls + "-input", (_a = {},
            _a[prefixCls + "-input-active"] = focusedInputIndex === index,
            _a[prefixCls + "-input-placeholder"] = isPlaceholder && focusedInputIndex === index,
            _a));
    }
    return (react.createElement("div", input_range_assign({ style: style, className: inputClassNames }, (0,omit/* default */.Z)(rest, ['onChange', 'onPressEnter'])),
        prefix && react.createElement("div", { className: prefixCls + "-prefix" }, prefix),
        react.createElement("div", { className: getFocusInputClassName(0) },
            react.createElement("input", input_range_assign({ ref: input0, disabled: disabled1, placeholder: placeholder[0], value: getInputValue(0), onChange: onChangeInput, onKeyDown: onKeyDown, onClick: function () { return changeFocusedInput(0); } }, readOnlyProps))),
        react.createElement("span", { className: prefixCls + "-separator" }, separator || '-'),
        react.createElement("div", { className: getFocusInputClassName(1) },
            react.createElement("input", input_range_assign({ ref: input1, disabled: disabled2, placeholder: placeholder[1], value: getInputValue(1), onChange: onChangeInput, onKeyDown: onKeyDown, onClick: function () { return changeFocusedInput(1); } }, readOnlyProps))),
        react.createElement("div", { className: prefixCls + "-suffix" },
            allowClear && value.length === 2 && (react.createElement(icon_hover/* default */.Z, { prefix: prefixCls, onClick: onClear, className: prefixCls + "-clear-icon" },
                react.createElement(IconClose/* default */.Z, null))),
            react.createElement("span", { className: prefixCls + "-suffix-icon" }, suffixIcon))));
}
/* harmony default export */ var input_range = ((0,react.forwardRef)(input_range_DateInput));

// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(82492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/pad.js
var pad = __webpack_require__(33091);
// EXTERNAL MODULE: ./node_modules/b-tween/dist/b-tween.es.js
var b_tween_es = __webpack_require__(37213);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/TimePicker/util.js



function getColumnsFromFormat(format) {
    var units = ['H', 'h', 'm', 's', 'a', 'A'];
    var list = [];
    var use12Hours = false;
    units.forEach(function (unit) {
        if (format.indexOf(unit) !== -1) {
            list.push(unit);
            if (unit === 'a' || unit === 'A') {
                use12Hours = true;
            }
        }
    });
    return {
        list: list,
        use12Hours: use12Hours,
    };
}
var scrollIds = new Map();
function scrollTo(element, to, duration) {
    if (scrollIds.get(element)) {
        cancelAnimationFrame(scrollIds.get(element));
    }
    if (duration <= 0) {
        element.scrollTop = to;
    }
    scrollIds.set(element, requestAnimationFrame(function () {
        var tween = new b_tween_es/* default */.Z({
            from: { scrollTop: element.scrollTop },
            to: { scrollTop: to },
            duration: duration,
            onUpdate: function (keys) {
                element.scrollTop = keys.scrollTop;
            },
            easing: 'quartInOut',
        });
        tween.start();
    }));
}
function getFormatTime(time) {
    var today = dayjs();
    var y = today.year();
    var m = today.month();
    var d = today.date();
    if (isDayjs(time)) {
        var returnTime = time;
        returnTime = methods.set(returnTime, 'year', y);
        returnTime = methods.set(returnTime, 'month', m);
        returnTime = methods.set(returnTime, 'date', d);
        return returnTime;
    }
    return time;
}

// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/TimePicker/time-column.js





function TimeColumn(props) {
    var prefixCls = props.prefixCls, list = props.list, value = props.value, onHandleSelect = props.onHandleSelect, unit = props.unit, popupVisible = props.popupVisible, scrollSticky = props.scrollSticky;
    var lis = (0,react.useRef)(new Map());
    var wrapper = (0,react.useRef)();
    var ul = (0,react.useRef)();
    var listItemHeight = (0,react.useRef)(0);
    var prevPopupVisible = (0,usePrevious/* default */.Z)(popupVisible);
    var prevScrollTop = (0,react.useRef)(wrapper.current && wrapper.current.scrollTop);
    (0,react.useEffect)(function () {
        var li = lis.current.get(value);
        if (li && popupVisible && prevPopupVisible) {
            scrollTo(wrapper.current, li.offsetTop, 150);
            prevScrollTop.current = li.offsetTop;
        }
    }, [value]);
    (0,react.useEffect)(function () {
        if (popupVisible && popupVisible !== prevPopupVisible) {
            var li = lis.current.get(value);
            if (li) {
                scrollTo(wrapper.current, li.offsetTop, 0);
                prevScrollTop.current = li.offsetTop;
            }
        }
    }, [popupVisible, prevPopupVisible]);
    (0,react.useEffect)(function () {
        if (list.length <= 1) {
            return;
        }
        listItemHeight.current =
            (ul.current.clientHeight - wrapper.current.clientHeight) / (list.length - 1);
    }, [list.length]);
    var onScrollList = (0,react.useCallback)(debounce_default()(function () {
        var mathFunc = wrapper.current.scrollTop - prevScrollTop.current > 0 ? Math.ceil : Math.floor;
        var index = mathFunc(wrapper.current.scrollTop / listItemHeight.current);
        if (index !== value && list[index] && !list[index].disabled) {
            onHandleSelect(list[index].value, unit);
        }
    }, 100), [onHandleSelect]);
    return (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-list"), ref: wrapper, onWheel: scrollSticky ? onScrollList : undefined },
        react.createElement("ul", { ref: ul }, list.map(function (item) {
            var _a;
            return (react.createElement("li", { key: item.value, className: (0,_util_classNames/* default */.Z)(prefixCls + "-cell", (_a = {},
                    _a[prefixCls + "-cell-disabled"] = item.disabled,
                    _a[prefixCls + "-cell-selected"] = item.selected,
                    _a)), onClick: function () { return !item.disabled && onHandleSelect(item.value, unit); }, ref: function (element) {
                    lis.current.set(item.value, element);
                } },
                react.createElement("div", { className: prefixCls + "-cell-inner" }, item.label)));
        }))));
}

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/TimePicker/context.js

/* harmony default export */ var TimePicker_context = ((0,react.createContext)({}));

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/TimePicker/time-picker.js
var time_picker_assign = (undefined && undefined.__assign) || function () {
    time_picker_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return time_picker_assign.apply(this, arguments);
};









var AMPM = ['am', 'pm'];
function isUse12Hours(props) {
    var _a;
    return (_a = props.use12Hours) !== null && _a !== void 0 ? _a : getColumnsFromFormat(props.format).use12Hours;
}
function TimePicker(props) {
    var _a = props.format, format = _a === void 0 ? 'HH:mm:ss' : _a, onSelect = props.onSelect, popupVisible = props.popupVisible, _b = props.step, step = _b === void 0 ? {} : _b, disabledHours = props.disabledHours, disabledMinutes = props.disabledMinutes, disabledSeconds = props.disabledSeconds, hideDisabledOptions = props.hideDisabledOptions, onConfirmValue = props.onConfirmValue, isRangePicker = props.isRangePicker, confirmBtnDisabled = props.confirmBtnDisabled, propsValueShow = props.valueShow, setValueShow = props.setValueShow, extra = props.extra, disableConfirm = props.disableConfirm, hideFooter = props.hideFooter, _c = props.showNowBtn, showNowBtn = _c === void 0 ? true : _c, scrollSticky = props.scrollSticky;
    var _d = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _d.getPrefixCls, locale = _d.locale;
    var prefixCls = getPrefixCls('timepicker');
    var _e = (0,react.useContext)(TimePicker_context), utcOffset = _e.utcOffset, timezone = _e.timezone;
    var valueShow = (0,_util_dayjs/* getDayjsValue */.p3)(propsValueShow, format);
    var ampm = valueShow && valueShow.hour() >= 12 ? 'pm' : 'am';
    var use12Hours = isUse12Hours(props);
    var getShowList = (0,react.useCallback)(function (type) {
        var stepHour = step.hour || 1;
        var stepMinute = step.minute || 1;
        var stepSecond = step.second || 1;
        var list = [];
        if (type === 'hour') {
            for (var i = 0; i < (use12Hours ? 12 : 24); i += stepHour) {
                list.push(i);
            }
            if (use12Hours) {
                list[0] = 12;
            }
        }
        if (type === 'minute') {
            for (var i = 0; i < 60; i += stepMinute) {
                list.push(i);
            }
        }
        if (type === 'second') {
            for (var i = 0; i < 60; i += stepSecond) {
                list.push(i);
            }
        }
        return list;
    }, [step.hour, step.minute, step.second, use12Hours]);
    var HOURS = getShowList('hour');
    var MINUTES = getShowList('minute');
    var SECONDS = getShowList('second');
    var selectedHour = valueShow && valueShow.hour();
    selectedHour = use12Hours ? (selectedHour > 12 ? selectedHour - 12 : selectedHour) : selectedHour;
    if (use12Hours && selectedHour === 0 && ampm === 'am') {
        selectedHour += 12;
    }
    var selectedMinute = valueShow && valueShow.minute();
    var selectedSecond = valueShow && valueShow.second();
    var getDefaultStr = (0,react.useCallback)(function (type) {
        switch (type) {
            case 'hour':
                return typeof disabledHours === 'function'
                    ? (0,pad/* padStart */.S)(HOURS.find(function (h) { return disabledHours().indexOf(h) === -1; }) || 0, 2, '0')
                    : (0,pad/* padStart */.S)(HOURS[0], 2, '0');
            case 'minute':
                return typeof disabledMinutes === 'function'
                    ? (0,pad/* padStart */.S)(MINUTES.find(function (m) { return disabledMinutes(selectedHour).indexOf(m) === -1; }) || 0, 2, '0')
                    : (0,pad/* padStart */.S)(MINUTES[0], 2, '0');
            case 'second':
                return typeof disabledSeconds === 'function'
                    ? (0,pad/* padStart */.S)(SECONDS.find(function (s) { return disabledSeconds(selectedHour, selectedMinute).indexOf(s) === -1; }) || 0, 2, '0')
                    : (0,pad/* padStart */.S)(SECONDS[0], 2, '0');
            default:
                return '00';
        }
    }, [
        HOURS,
        MINUTES,
        SECONDS,
        disabledHours,
        disabledMinutes,
        disabledSeconds,
        selectedHour,
        selectedMinute,
    ]);
    function onHandleSelect(selectedValue, unit) {
        var _a, _b, _c;
        var isUpperCase = getColumnsFromFormat(format).list.indexOf('A') !== -1;
        var _valueShow = valueShow ||
            (0,_util_dayjs/* dayjs */.Bv)(getDefaultStr('hour') + ":" + getDefaultStr('minute') + ":" + getDefaultStr('second'), 'HH:mm:ss');
        var hour = _valueShow.hour();
        var minute = _valueShow.minute();
        var second = _valueShow.second();
        var selectedAmpm = isUpperCase ? ampm.toUpperCase() : ampm;
        var valueFormat = 'HH:mm:ss';
        var newValue;
        if (use12Hours) {
            if (isUpperCase) {
                valueFormat = valueFormat + " A";
            }
            else {
                valueFormat = valueFormat + " a";
            }
        }
        if (use12Hours) {
            hour = hour > 12 ? hour - 12 : hour;
        }
        if (unit === 'hour') {
            if (typeof disabledMinutes === 'function' &&
                disabledMinutes(selectedValue).includes(minute)) {
                minute = (_a = MINUTES.find(function (m) { return disabledMinutes(selectedValue).indexOf(m) === -1; })) !== null && _a !== void 0 ? _a : 0;
            }
            if (typeof disabledSeconds === 'function' &&
                disabledSeconds(selectedValue, minute).includes(second)) {
                second = (_b = SECONDS.find(function (s) { return disabledSeconds(selectedValue, minute).indexOf(s) === -1; })) !== null && _b !== void 0 ? _b : 0;
            }
            newValue = (0,_util_dayjs/* dayjs */.Bv)(selectedValue + ":" + minute + ":" + second + " " + selectedAmpm, valueFormat, 'en');
        }
        if (unit === 'minute') {
            if (typeof disabledSeconds === 'function' &&
                disabledSeconds(hour, selectedValue).includes(second)) {
                second = (_c = SECONDS.find(function (s) { return disabledSeconds(hour, selectedValue).indexOf(s) === -1; })) !== null && _c !== void 0 ? _c : 0;
            }
            newValue = (0,_util_dayjs/* dayjs */.Bv)(hour + ":" + selectedValue + ":" + second + " " + selectedAmpm, valueFormat, 'en');
        }
        if (unit === 'second') {
            newValue = (0,_util_dayjs/* dayjs */.Bv)(hour + ":" + minute + ":" + selectedValue + " " + selectedAmpm, valueFormat, 'en');
        }
        if (unit === 'ampm') {
            newValue = (0,_util_dayjs/* dayjs */.Bv)(hour + ":" + minute + ":" + second + " " + (isUpperCase ? selectedValue.toUpperCase() : selectedValue), valueFormat, 'en');
        }
        newValue = (0,_util_dayjs/* dayjs */.Bv)(newValue, valueFormat).locale(_util_dayjs/* dayjs.locale */.Bv.locale());
        onSelect &&
            onSelect((0,_util_dayjs/* toLocal */.sB)(newValue, utcOffset, timezone).format(format), (0,_util_dayjs/* toLocal */.sB)(newValue, utcOffset, timezone));
        if (!isRangePicker) {
            setValueShow && setValueShow(newValue);
            if (disableConfirm) {
                onConfirmValue(newValue);
            }
        }
    }
    function onConfirmTime() {
        if (valueShow) {
            onConfirmValue(valueShow);
        }
    }
    function onSelectNow() {
        var now = (0,_util_dayjs/* getNow */.Iz)();
        var zoneNow = (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone);
        onSelect && onSelect(now.format(format), now);
        if (disableConfirm) {
            onConfirmValue(zoneNow);
        }
        else {
            setValueShow && setValueShow(zoneNow);
        }
    }
    var baseTimeColumnProps = {
        prefixCls: prefixCls,
        onHandleSelect: onHandleSelect,
        popupVisible: popupVisible,
        scrollSticky: scrollSticky,
    };
    function renderHours() {
        var hours = hideDisabledOptions && typeof disabledHours === 'function'
            ? HOURS.filter(function (h) { return disabledHours().indexOf(h) === -1; })
            : HOURS;
        var list = hours.map(function (h) { return ({
            label: (0,pad/* padStart */.S)("" + h, 2, '0'),
            value: h,
            selected: selectedHour !== undefined && selectedHour === h,
            disabled: typeof disabledHours === 'function' && disabledHours().indexOf(h) !== -1,
        }); });
        return react.createElement(TimeColumn, time_picker_assign({}, baseTimeColumnProps, { list: list, value: selectedHour, unit: "hour" }));
    }
    function renderMinutes() {
        var minutes = hideDisabledOptions && typeof disabledMinutes === 'function'
            ? MINUTES.filter(function (h) { return disabledMinutes(selectedHour).indexOf(h) === -1; })
            : MINUTES;
        var list = minutes.map(function (m) { return ({
            label: (0,pad/* padStart */.S)("" + m, 2, '0'),
            value: m,
            selected: selectedHour !== undefined && selectedMinute === m,
            disabled: typeof disabledMinutes === 'function' && disabledMinutes(selectedHour).indexOf(m) !== -1,
        }); });
        return react.createElement(TimeColumn, time_picker_assign({}, baseTimeColumnProps, { list: list, value: selectedMinute, unit: "minute" }));
    }
    function renderSeconds() {
        var seconds = hideDisabledOptions && typeof disabledSeconds === 'function'
            ? SECONDS.filter(function (h) { return disabledSeconds(selectedHour, selectedMinute).indexOf(h) === -1; })
            : SECONDS;
        var list = seconds.map(function (s) { return ({
            label: (0,pad/* padStart */.S)("" + s, 2, '0'),
            value: s,
            selected: selectedHour !== undefined && selectedSecond === s,
            disabled: typeof disabledSeconds === 'function' &&
                disabledSeconds(selectedHour, selectedMinute).indexOf(s) !== -1,
        }); });
        return react.createElement(TimeColumn, time_picker_assign({}, baseTimeColumnProps, { list: list, value: selectedSecond, unit: "second" }));
    }
    function renderAmPm() {
        var isUpperCase = getColumnsFromFormat(format).list.indexOf('A') !== -1;
        var list = AMPM.map(function (a) { return ({
            label: isUpperCase ? a.toUpperCase() : a,
            value: a,
            selected: ampm === a,
        }); });
        return react.createElement(TimeColumn, time_picker_assign({}, baseTimeColumnProps, { list: list, value: ampm, unit: "ampm" }));
    }
    var list = getColumnsFromFormat(format).list;
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls);
    var _hideFooter = hideFooter ||
        (disableConfirm && isRangePicker) ||
        (!isRangePicker && disableConfirm && !showNowBtn);
    return (react.createElement(react.Fragment, null,
        react.createElement("div", { className: classNames },
            (list.indexOf('H') !== -1 || list.indexOf('h') !== -1) && renderHours(),
            list.indexOf('m') !== -1 && renderMinutes(),
            list.indexOf('s') !== -1 && renderSeconds(),
            use12Hours && renderAmPm()),
        extra && react.createElement("div", { className: prefixCls + "-footer-extra-wrapper" }, extra),
        !_hideFooter && (react.createElement("div", { className: prefixCls + "-footer-btn-wrapper" },
            !isRangePicker && showNowBtn ? (react.createElement(Button/* default */.Z, { size: "mini", onClick: onSelectNow }, locale.TimePicker.now)) : (react.createElement("div", null)),
            !disableConfirm && (react.createElement(Button/* default */.Z, { type: "primary", size: "mini", onClick: onConfirmTime, disabled: confirmBtnDisabled || !valueShow }, locale.TimePicker.ok))))));
}
/* harmony default export */ var time_picker = (TimePicker);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLeft/index.js
var IconLeft = __webpack_require__(42355);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconRight/index.js
var IconRight = __webpack_require__(826);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconDoubleLeft/index.js



function IconDoubleLeft_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function IconDoubleLeft_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { IconDoubleLeft_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { IconDoubleLeft_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconDoubleLeftComponent(iconProps, ref) {
  var _useContext = (0,react.useContext)(context/* IconContext */.P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = IconDoubleLeft_objectSpread(IconDoubleLeft_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-double-left")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react.createElement("svg", (0,esm_extends/* default */.Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M36.857 9.9 22.715 24.042l14.142 14.142M25.544 9.9 11.402 24.042l14.142 14.142"
  }));
}

var IconDoubleLeft = /*#__PURE__*/react.forwardRef(IconDoubleLeftComponent);
IconDoubleLeft.defaultProps = {
  isIcon: true
};
IconDoubleLeft.displayName = 'IconDoubleLeft';
/* harmony default export */ var react_icon_IconDoubleLeft = (IconDoubleLeft);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconDoubleRight/index.js
var IconDoubleRight = __webpack_require__(27638);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/panels/header.js






function Header(props) {
    var prefixCls = props.prefixCls, title = props.title, onPrev = props.onPrev, onNext = props.onNext, onSuperPrev = props.onSuperPrev, onSuperNext = props.onSuperNext, mode = props.mode, value = props.value, onChangePanel = props.onChangePanel, _a = props.icons, icons = _a === void 0 ? {} : _a, rtl = props.rtl, DATEPICKER_LOCALE = props.DATEPICKER_LOCALE;
    var showPrev = typeof onPrev === 'function';
    var showSuperPrev = typeof onSuperPrev === 'function';
    var showNext = typeof onNext === 'function';
    var showSuperNext = typeof onSuperNext === 'function';
    var getIconClassName = function (isShow) {
        var _a;
        return (0,_util_classNames/* default */.Z)(prefixCls + "-header-icon", (_a = {}, _a[prefixCls + "-header-icon-hidden"] = !isShow, _a));
    };
    function renderHeaderLabel() {
        if (title) {
            return title;
        }
        if (mode === 'date' || mode === 'week') {
            var monthBeforeYear = ((DATEPICKER_LOCALE === null || DATEPICKER_LOCALE === void 0 ? void 0 : DATEPICKER_LOCALE.Calendar) || {}).monthBeforeYear;
            var yearNode = (react.createElement("span", { className: prefixCls + "-header-label", onClick: function () { return onChangePanel('year'); } }, value.format('YYYY')));
            var monthNode = (react.createElement("span", { className: prefixCls + "-header-label", onClick: function () { return onChangePanel('month'); } }, value.format('MM')));
            return monthBeforeYear ? (react.createElement(react.Fragment, null,
                monthNode,
                "/",
                yearNode)) : (react.createElement(react.Fragment, null,
                yearNode,
                "-",
                monthNode));
        }
        if (mode === 'month' || mode === 'quarter') {
            return (react.createElement("span", { className: prefixCls + "-header-label", onClick: function () { return onChangePanel('year'); } }, value.format('YYYY')));
        }
    }
    var prevDoubleNull = icons.prevDouble === null;
    var prevNull = icons.prev === null;
    var nextNull = icons.next === null;
    var nextDoubleNull = icons.nextDouble === null;
    return (react.createElement("div", { className: prefixCls + "-header" },
        !prevDoubleNull && (react.createElement("div", { className: getIconClassName(showSuperPrev), onClick: onSuperPrev }, showSuperPrev &&
            (prevDoubleNull
                ? null
                : icons.prevDouble || (rtl ? react.createElement(IconDoubleRight/* default */.Z, null) : react.createElement(react_icon_IconDoubleLeft, null))))),
        !prevNull && (react.createElement("div", { className: getIconClassName(showPrev), onClick: onPrev }, showPrev && (prevNull ? null : icons.prev || (rtl ? react.createElement(IconRight/* default */.Z, null) : react.createElement(IconLeft/* default */.Z, null))))),
        react.createElement("div", { className: prefixCls + "-header-value" }, renderHeaderLabel()),
        !nextNull && (react.createElement("div", { className: getIconClassName(showNext), onClick: onNext }, showNext && (nextNull ? null : icons.next || (rtl ? react.createElement(IconLeft/* default */.Z, null) : react.createElement(IconRight/* default */.Z, null))))),
        !nextDoubleNull && (react.createElement("div", { className: getIconClassName(showSuperNext), onClick: onSuperNext }, showSuperNext &&
            (nextDoubleNull
                ? null
                : icons.nextDouble || (rtl ? react.createElement(react_icon_IconDoubleLeft, null) : react.createElement(IconDoubleRight/* default */.Z, null)))))));
}
/* harmony default export */ var header = (Header);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/panels/week-list.js

function WeekList(props) {
    var prefixCls = props.prefixCls, weekStart = props.weekStart, isWeek = props.isWeek, CALENDAR_LOCALE = props.CALENDAR_LOCALE;
    var weekList = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    weekList = weekList.slice(weekStart).concat(weekList.slice(0, weekStart));
    if (isWeek) {
        weekList.unshift('');
    }
    var weekLocale = CALENDAR_LOCALE.week.short;
    return (react.createElement("div", { className: prefixCls + "-week-list" }, weekList.map(function (w) { return (react.createElement("div", { className: prefixCls + "-week-list-item", key: w }, w && weekLocale[w])); })));
}
/* harmony default export */ var week_list = (WeekList);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/hooks/useCellClassName.js




function getDateValue(date, index) {
    if (!date) {
        return undefined;
    }
    if ((0,is/* isArray */.kJ)(date)) {
        return date[index];
    }
}
function useClassName(props) {
    var prefixCls = props.prefixCls, value = props.value, rangeValues = props.rangeValues, valueShowHover = props.valueShowHover, isSameTime = props.isSameTime, mode = props.mode, hideNotInViewDates = props.hideNotInViewDates;
    var selectedLength = getAvailableDayjsLength(rangeValues);
    var hoverLength = getAvailableDayjsLength(valueShowHover);
    var sortedRangeValues = selectedLength !== 2 && hoverLength === 2 ? (0,_util_dayjs/* getSortedDayjsArray */.ul)(valueShowHover) : rangeValues;
    var sortedHoverRangeValues = selectedLength === 2 ? (0,_util_dayjs/* getSortedDayjsArray */.ul)(valueShowHover) : [];
    function isInRange(current, startDate, endDate) {
        // show placeholder range
        // if (!startDate || !endDate) {
        //   if (startDate) {
        //     return isSameTime(current, startDate) || current.isAfter(startDate);
        //   }
        //   if (endDate) {
        //     return isSameTime(current, endDate) || current.isBefore(endDate);
        //   }
        //   return false;
        // }
        if (startDate && endDate) {
            return (isSameTime(current, startDate) ||
                isSameTime(current, endDate) ||
                current.isBetween(startDate, endDate, null));
        }
    }
    return function getCellClassName(cellDateObj, disabled, utcOffset, timezone) {
        var _a;
        var rangeStart = getDateValue(sortedRangeValues, 0);
        var rangeEnd = getDateValue(sortedRangeValues, 1);
        var hoverRangeStart = getDateValue(sortedHoverRangeValues, 0);
        var hoverRangeEnd = getDateValue(sortedHoverRangeValues, 1);
        var isInView = !cellDateObj.isPrev && !cellDateObj.isNext;
        var selected = value && isSameTime(cellDateObj.time, value);
        var isToday = isSameTime(cellDateObj.time, (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone));
        var checkIsInView = mode !== 'week' ? isInView : true;
        if (mode === 'week') {
            isToday = (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone).isSame(cellDateObj.time, 'date');
        }
        if (mode === 'quarter') {
            isToday = (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone).isSame(cellDateObj.time, 'quarter');
        }
        function getIsRangeStartOrEnd(v) {
            return checkIsInView && !disabled && v && isSameTime(cellDateObj.time, v);
        }
        var isRangeStart = getIsRangeStartOrEnd(rangeStart);
        var isRangeEnd = getIsRangeStartOrEnd(rangeEnd);
        var isRangeStartSelected = getIsRangeStartOrEnd(getDateValue(rangeValues, 0));
        var isRangeEndSelected = getIsRangeStartOrEnd(getDateValue(rangeValues, 1));
        var isHoverRangeStart = getIsRangeStartOrEnd(hoverRangeStart);
        var isHoverRangeEnd = getIsRangeStartOrEnd(hoverRangeEnd);
        var isRangeEdgeInHoverRange = false;
        if (isRangeStart) {
            isRangeEdgeInHoverRange =
                hoverRangeStart &&
                    rangeStart &&
                    hoverRangeStart.isBefore(rangeStart) &&
                    isInRange(rangeStart, hoverRangeStart, hoverRangeEnd);
        }
        else if (isRangeEnd) {
            isRangeEdgeInHoverRange =
                hoverRangeEnd &&
                    rangeEnd &&
                    hoverRangeEnd.isAfter(rangeEnd) &&
                    isInRange(rangeEnd, hoverRangeStart, hoverRangeEnd);
        }
        var isHoverRangeEdgeInRange = false;
        if (isHoverRangeStart) {
            isHoverRangeEdgeInRange =
                hoverRangeStart &&
                    rangeStart &&
                    rangeStart.isBefore(hoverRangeStart) &&
                    isInRange(hoverRangeStart, rangeStart, rangeEnd);
        }
        else if (isHoverRangeEnd) {
            isHoverRangeEdgeInRange =
                hoverRangeEnd &&
                    rangeEnd &&
                    rangeEnd.isAfter(hoverRangeEnd) &&
                    isInRange(hoverRangeEnd, rangeStart, rangeEnd);
        }
        return (0,_util_classNames/* default */.Z)(prefixCls + "-cell", (_a = {},
            _a[prefixCls + "-cell-disabled"] = disabled,
            _a[prefixCls + "-cell-hidden"] = hideNotInViewDates && !isInView,
            _a[prefixCls + "-cell-in-view"] = isInView,
            _a[prefixCls + "-cell-today"] = isToday && isInView,
            _a[prefixCls + "-cell-selected"] = selected || isRangeStartSelected || isRangeEndSelected,
            _a[prefixCls + "-cell-range-start"] = isRangeStart,
            _a[prefixCls + "-cell-range-end"] = isRangeEnd,
            _a[prefixCls + "-cell-in-range"] = checkIsInView && !disabled && isInRange(cellDateObj.time, rangeStart, rangeEnd),
            _a[prefixCls + "-cell-hover-range-start"] = isHoverRangeStart,
            _a[prefixCls + "-cell-hover-range-end"] = isHoverRangeEnd,
            _a[prefixCls + "-cell-hover-in-range"] = checkIsInView && !disabled && isInRange(cellDateObj.time, hoverRangeStart, hoverRangeEnd),
            _a[prefixCls + "-cell-range-edge-in-hover-range"] = isRangeEdgeInHoverRange,
            _a[prefixCls + "-cell-hover-range-edge-in-range"] = isHoverRangeEdgeInRange,
            _a));
    };
}

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/panels/body.js
var body_assign = (undefined && undefined.__assign) || function () {
    body_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return body_assign.apply(this, arguments);
};






function Body(props) {
    var prefixCls = props.prefixCls, isWeek = props.isWeek, disabledDate = props.disabledDate, onSelectDate = props.onSelectDate, dateRender = props.dateRender, onMouseEnterCell = props.onMouseEnterCell, onMouseLeaveCell = props.onMouseLeaveCell, CALENDAR_LOCALE = props.CALENDAR_LOCALE, rows = props.rows, showWeekList = props.showWeekList, isSameTime = props.isSameTime, format = props.format, mode = props.mode;
    var _a = (0,react.useContext)(DatePicker_context), utcOffset = _a.utcOffset, timezone = _a.timezone, weekStart = _a.weekStart;
    var getCellClassName = useClassName(body_assign(body_assign({}, props), { isSameTime: isSameTime }));
    function renderRow(row) {
        return row.map(function (col, index) {
            if (col.time) {
                var disabled_1 = isDisabledDate(col.time, disabledDate, mode);
                var onClickHandler = function () { return !disabled_1 && onSelectDate(col.time.format(format), col.time); };
                return (react.createElement("div", { key: index, className: getCellClassName(col, disabled_1, utcOffset, timezone), onMouseEnter: function () { return onMouseEnterCell && onMouseEnterCell(col.time, disabled_1); }, onMouseLeave: function () { return onMouseLeaveCell && onMouseLeaveCell(col.time, disabled_1); }, onClick: onClickHandler }, dateRender ? (react.cloneElement(dateRender(col.time))) : (react.createElement("div", { className: prefixCls + "-date" },
                    react.createElement("div", { className: prefixCls + "-date-value" }, col.name)))));
            }
            if ('weekOfYear' in col) {
                return (react.createElement("div", { key: index, className: (0,_util_classNames/* default */.Z)(prefixCls + "-cell", prefixCls + "-cell-week") },
                    react.createElement("div", { className: prefixCls + "-date" },
                        react.createElement("div", { className: prefixCls + "-date-value" }, col.weekOfYear))));
            }
        });
    }
    return (react.createElement(react.Fragment, null,
        showWeekList && (react.createElement(week_list, { prefixCls: prefixCls, weekStart: weekStart, isWeek: isWeek, CALENDAR_LOCALE: CALENDAR_LOCALE })),
        react.createElement("div", { className: prefixCls + "-body" }, rows.map(function (row, index) {
            var _a;
            return (react.createElement("div", { key: index, className: (0,_util_classNames/* default */.Z)(prefixCls + "-row", (_a = {}, _a[prefixCls + "-row-week"] = isWeek, _a)) }, renderRow(row)));
        }))));
}
/* harmony default export */ var body = (Body);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/constant.js
var constant = __webpack_require__(91702);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/panels/year/index.js
var year_assign = (undefined && undefined.__assign) || function () {
    year_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return year_assign.apply(this, arguments);
};
var year_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};









function YearPicker(props) {
    var pageShowDate = props.pageShowDate, style = props.style, onMouseEnterCell = props.onMouseEnterCell, onMouseLeaveCell = props.onMouseLeaveCell, dateRender = props.dateRender, disabledDate = props.disabledDate, value = props.value, locale = props.locale, isRangePicker = props.isRangePicker, onSelect = props.onSelect, rangeValues = props.rangeValues, onSuperPrev = props.onSuperPrev, onSuperNext = props.onSuperNext, format = props.format, icons = props.icons, rest = year_rest(props, ["pageShowDate", "style", "onMouseEnterCell", "onMouseLeaveCell", "dateRender", "disabledDate", "value", "locale", "isRangePicker", "onSelect", "rangeValues", "onSuperPrev", "onSuperNext", "format", "icons"]);
    var _a = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), globalLocale = _a.locale, getPrefixCls = _a.getPrefixCls, rtl = _a.rtl;
    var DATEPICKER_LOCALE = merge_default()(globalLocale.DatePicker, locale);
    var CALENDAR_LOCALE = DATEPICKER_LOCALE.Calendar;
    var _b = (0,react.useContext)(DatePicker_context), utcOffset = _b.utcOffset, timezone = _b.timezone;
    var prefixCls = getPrefixCls('panel-year');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls);
    var bodyProps = isRangePicker ? { rangeValues: rangeValues } : { value: value };
    var showYear = pageShowDate ? pageShowDate.year() : (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone).year();
    var startYear = Math.floor(showYear / 10) * 10 - 1;
    var groupRow = (0,constant/* newArray */.B4)(3).map(function (_) { return ''; });
    var rows = (0,constant/* newArray */.B4)(4)
        .map(function (_) { return groupRow; })
        .map(function (arr, i) {
        return arr.map(function (_, j) {
            return {
                name: startYear + i * 3 + j,
                time: (0,_util_dayjs/* dayjs */.Bv)("" + (startYear + i * 3 + j), 'YYYY').endOf('year'),
                isPrev: i === 0 && j === 0,
                isNext: i === 3 && j === 2,
            };
        });
    });
    function renderCalendar() {
        return (react.createElement(body, year_assign({}, rest, bodyProps, { prefixCls: getPrefixCls('picker'), rows: rows, onSelectDate: onSelect, isSameTime: function (current, target) { return current.isSame(target, 'year'); }, onMouseEnterCell: onMouseEnterCell, onMouseLeaveCell: onMouseLeaveCell, dateRender: dateRender, disabledDate: disabledDate, CALENDAR_LOCALE: CALENDAR_LOCALE, mode: "year", format: format })));
    }
    var headerOperations = { onSuperPrev: onSuperPrev, onSuperNext: onSuperNext };
    return (react.createElement("div", { className: classNames, style: style },
        react.createElement(header, year_assign({ prefixCls: getPrefixCls('picker'), icons: icons, title: rows[0][1].name + " - " + rows[3][2].name, rtl: rtl }, headerOperations)),
        renderCalendar()));
}
/* harmony default export */ var year = (YearPicker);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/panels/month/index.js
var month_assign = (undefined && undefined.__assign) || function () {
    month_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return month_assign.apply(this, arguments);
};
var month_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};









function MonthPicker(props) {
    var pageShowDate = props.pageShowDate, style = props.style, onMouseEnterCell = props.onMouseEnterCell, onMouseLeaveCell = props.onMouseLeaveCell, dateRender = props.dateRender, disabledDate = props.disabledDate, value = props.value, locale = props.locale, isRangePicker = props.isRangePicker, onSelect = props.onSelect, rangeValues = props.rangeValues, onSuperPrev = props.onSuperPrev, onSuperNext = props.onSuperNext, format = props.format, getHeaderOperations = props.getHeaderOperations, setPageShowDate = props.setPageShowDate, icons = props.icons, panelMode = props.panelMode, setPanelMode = props.setPanelMode, rest = month_rest(props, ["pageShowDate", "style", "onMouseEnterCell", "onMouseLeaveCell", "dateRender", "disabledDate", "value", "locale", "isRangePicker", "onSelect", "rangeValues", "onSuperPrev", "onSuperNext", "format", "getHeaderOperations", "setPageShowDate", "icons", "panelMode", "setPanelMode"]);
    var _a = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), globalLocale = _a.locale, getPrefixCls = _a.getPrefixCls, rtl = _a.rtl;
    var DATEPICKER_LOCALE = merge_default()(globalLocale.DatePicker, locale);
    var CALENDAR_LOCALE = DATEPICKER_LOCALE.Calendar;
    var prefixCls = getPrefixCls('panel-month');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls);
    var bodyProps = isRangePicker ? { rangeValues: rangeValues } : { value: value };
    var showYear = pageShowDate.year();
    var rows = (0,react.useMemo)(function () {
        var MONTHS = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ].map(function (month, index) {
            return {
                name: CALENDAR_LOCALE.month.short[month],
                time: (0,_util_dayjs/* dayjs */.Bv)(showYear + "-" + (0,pad/* padStart */.S)(index + 1, 2, '0'), 'YYYY-MM').endOf('month'),
            };
        });
        var monthGroup = Array(4);
        for (var i = 0; i < 4; i++) {
            monthGroup[i] = MONTHS.slice(i * 3, 3 * (i + 1));
        }
        return monthGroup;
    }, [showYear, CALENDAR_LOCALE]);
    function renderCalendar() {
        return (react.createElement(body, month_assign({}, rest, bodyProps, { prefixCls: getPrefixCls('picker'), rows: rows, onSelectDate: onSelect, isSameTime: function (current, target) { return current.isSame(target, 'month'); }, onMouseEnterCell: onMouseEnterCell, onMouseLeaveCell: onMouseLeaveCell, dateRender: dateRender, disabledDate: disabledDate, CALENDAR_LOCALE: CALENDAR_LOCALE, mode: "month", format: format })));
    }
    var headerOperations = { onSuperPrev: onSuperPrev, onSuperNext: onSuperNext };
    function onChangePanel(mode) {
        setPanelMode(mode);
    }
    if (panelMode === 'year') {
        return (react.createElement(year, month_assign({}, getHeaderOperations(panelMode), { pageShowDate: pageShowDate, onSelect: function (_, date) {
                setPanelMode('month');
                setPageShowDate(date);
            }, disabledDate: disabledDate })));
    }
    return (react.createElement("div", { className: classNames, style: style },
        react.createElement(header, month_assign({}, headerOperations, { DATEPICKER_LOCALE: DATEPICKER_LOCALE, icons: icons, prefixCls: getPrefixCls('picker'), value: pageShowDate, mode: panelMode, onChangePanel: onChangePanel, rtl: rtl })),
        renderCalendar()));
}
/* harmony default export */ var month = (MonthPicker);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/panels/date/index.js
var date_assign = (undefined && undefined.__assign) || function () {
    date_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return date_assign.apply(this, arguments);
};
var date_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var date_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};














var allDaysInOnePage = 6 * 7;
var getReturn = function (time) {
    return {
        year: time.year(),
        month: time.month() + 1,
        day: time.day(),
        name: time.date(),
        time: time,
    };
};
var getTimeObj = function (time) {
    return date_assign(date_assign({}, getReturn(_util_dayjs/* methods.startOf */.xB.startOf(time, 'month'))), { days: time.daysInMonth() });
};
function getAllDaysByTime(props, time) {
    var dayStartOfWeek = props.dayStartOfWeek, isWeek = props.isWeek;
    var current = getTimeObj(time);
    var flatRows = (0,constant/* newArray */.B4)(allDaysInOnePage).map(function () { return ({}); });
    var startIndex = current.day - dayStartOfWeek < 0
        ? 7 + (current.day - dayStartOfWeek)
        : current.day - dayStartOfWeek;
    flatRows[startIndex] = date_assign({}, current);
    // pre
    for (var i = 0; i < startIndex; i++) {
        flatRows[startIndex - i - 1] = date_assign(date_assign({}, getReturn(_util_dayjs/* methods.subtract */.xB.subtract(current.time, i + 1, 'day'))), { isPrev: true });
    }
    // next
    for (var i = 0; i < allDaysInOnePage - startIndex - 1; i++) {
        flatRows[startIndex + i + 1] = date_assign(date_assign({}, getReturn(_util_dayjs/* methods.add */.xB.add(current.time, i + 1, 'day'))), { isNext: i >= current.days - 1 });
    }
    var rows = (0,constant/* newArray */.B4)(6).map(function () { return []; });
    for (var i = 0; i < 6; i++) {
        rows[i] = flatRows.slice(i * 7, 7 * (i + 1));
        if (isWeek) {
            var weekTime = rows[i][0].time;
            var weekRows = __spreadArray([], date_read(rows[i]), false);
            rows[i].unshift({
                weekRows: weekRows,
                weekOfYear: weekTime.week(),
            });
        }
    }
    return rows;
}
function DatePicker(props) {
    var isWeek = props.isWeek, popupVisible = props.popupVisible, format = props.format, pageShowDate = props.pageShowDate, showTime = props.showTime, style = props.style, timepickerProps = props.timepickerProps, onMouseEnterCell = props.onMouseEnterCell, onMouseLeaveCell = props.onMouseLeaveCell, dateRender = props.dateRender, disabledDate = props.disabledDate, disabledTime = props.disabledTime, value = props.value, rangeValues = props.rangeValues, locale = props.locale, isRangePicker = props.isRangePicker, onSelect = props.onSelect, onTimePickerSelect = props.onTimePickerSelect, onPrev = props.onPrev, onNext = props.onNext, onSuperPrev = props.onSuperPrev, onSuperNext = props.onSuperNext, isSameTime = props.isSameTime, index = props.index, getHeaderOperations = props.getHeaderOperations, setPageShowDate = props.setPageShowDate, timeValue = props.timeValue, hideNotInViewDates = props.hideNotInViewDates, icons = props.icons, isTimePanel = props.isTimePanel, panelMode = props.panelMode, setPanelMode = props.setPanelMode, rest = date_rest(props, ["isWeek", "popupVisible", "format", "pageShowDate", "showTime", "style", "timepickerProps", "onMouseEnterCell", "onMouseLeaveCell", "dateRender", "disabledDate", "disabledTime", "value", "rangeValues", "locale", "isRangePicker", "onSelect", "onTimePickerSelect", "onPrev", "onNext", "onSuperPrev", "onSuperNext", "isSameTime", "index", "getHeaderOperations", "setPageShowDate", "timeValue", "hideNotInViewDates", "icons", "isTimePanel", "panelMode", "setPanelMode"]);
    var _a = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), globalLocale = _a.locale, getPrefixCls = _a.getPrefixCls, rtl = _a.rtl;
    var _b = (0,react.useContext)(DatePicker_context), utcOffset = _b.utcOffset, timezone = _b.timezone, weekStart = _b.weekStart;
    var DATEPICKER_LOCALE = merge_default()(globalLocale.DatePicker, locale);
    var prefixCls = getPrefixCls(isWeek ? 'panel-week' : 'panel-date');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls);
    var bodyProps = isRangePicker ? { rangeValues: rangeValues } : { value: value };
    var timeFormat = ((0,is/* isObject */.Kn)(showTime) && showTime.format) || (0,_util_dayjs/* getTimeFormat */.pv)(format);
    var dayjsLocale = globalLocale.dayjsLocale;
    // page data list
    var rows = (0,react.useMemo)(function () {
        return getAllDaysByTime(date_assign(date_assign({}, props), { dayStartOfWeek: weekStart }), pageShowDate.locale(dayjsLocale));
    }, [pageShowDate.toString(), weekStart, dayjsLocale]);
    var disabledTimeProps;
    if (isRangePicker) {
        disabledTimeProps =
            typeof disabledTime === 'function'
                ? disabledTime(rangeValues[index], index === 0 ? 'start' : 'end')
                : {};
    }
    else {
        disabledTimeProps =
            typeof disabledTime === 'function' ? disabledTime((0,_util_dayjs/* getDayjsValue */.p3)(value, format)) : {};
    }
    function renderCalendar() {
        return (react.createElement(body, date_assign({}, rest, bodyProps, { showWeekList: true, isWeek: isWeek, prefixCls: getPrefixCls('picker'), rows: rows, isSameTime: isSameTime || (function (current, target) { return current.isSame(target, 'day'); }), onSelectDate: onSelect, onMouseEnterCell: onMouseEnterCell, onMouseLeaveCell: onMouseLeaveCell, dateRender: dateRender, disabledDate: disabledDate, CALENDAR_LOCALE: DATEPICKER_LOCALE.Calendar, mode: isWeek ? 'week' : 'date', format: format, hideNotInViewDates: hideNotInViewDates })));
    }
    function renderTimePicker() {
        var showTimeProps = (0,is/* isObject */.Kn)(showTime) ? showTime : {};
        return (react.createElement("div", { className: prefixCls + "-timepicker" },
            react.createElement("header", { className: prefixCls + "-timepicker-title" }, DATEPICKER_LOCALE.selectTime),
            react.createElement(time_picker, date_assign({}, (0,omit/* default */.Z)(timepickerProps, ['disableConfirm']), showTimeProps, disabledTimeProps, { hideFooter: true, format: timeFormat, valueShow: timeValue.format(timeFormat), onSelect: onTimePickerSelect, popupVisible: popupVisible, utcOffset: utcOffset, timezone: timezone }))));
    }
    var headerOperations = { onPrev: onPrev, onSuperPrev: onSuperPrev, onNext: onNext, onSuperNext: onSuperNext, DATEPICKER_LOCALE: DATEPICKER_LOCALE };
    function onChangePanel(mode) {
        setPanelMode(mode);
    }
    if (panelMode === 'year') {
        return (react.createElement(year, date_assign({}, getHeaderOperations(panelMode), { pageShowDate: pageShowDate, onSelect: function (_, date) {
                setPanelMode('month');
                setPageShowDate(date);
            }, disabledDate: disabledDate })));
    }
    if (panelMode === 'month') {
        return (react.createElement(month, date_assign({}, getHeaderOperations(panelMode), { setPageShowDate: setPageShowDate, pageShowDate: pageShowDate, panelMode: panelMode, getHeaderOperations: getHeaderOperations, onSelect: function (_, date) {
                setPanelMode('date');
                setPageShowDate(date);
            }, disabledDate: disabledDate, setPanelMode: setPanelMode })));
    }
    return (react.createElement("div", { className: classNames, style: style }, showTime && isTimePanel ? (renderTimePicker()) : (react.createElement("div", { className: prefixCls + "-inner" },
        react.createElement(header, date_assign({}, headerOperations, { icons: icons, prefixCls: getPrefixCls('picker'), value: pageShowDate, mode: panelMode, onChangePanel: onChangePanel, rtl: rtl })),
        renderCalendar()))));
}
/* harmony default export */ var date = (DatePicker);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/panels/week/index.js
var week_assign = (undefined && undefined.__assign) || function () {
    week_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return week_assign.apply(this, arguments);
};
var week_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




function WeekPicker(props) {
    var value = props.value, isRangePicker = props.isRangePicker, rangeValues = props.rangeValues, onPrev = props.onPrev, onNext = props.onNext, onSuperPrev = props.onSuperPrev, onSuperNext = props.onSuperNext, localeName = props.localeName, rest = week_rest(props, ["value", "isRangePicker", "rangeValues", "onPrev", "onNext", "onSuperPrev", "onSuperNext", "localeName"]);
    var weekStart = (0,react.useContext)(DatePicker_context).weekStart;
    var bodyProps = isRangePicker ? { rangeValues: rangeValues } : { value: value };
    var headerOperations = { onPrev: onPrev, onNext: onNext, onSuperPrev: onSuperPrev, onSuperNext: onSuperNext };
    function isSameTime(current, target) {
        return _util_dayjs/* methods.isSameWeek */.xB.isSameWeek(current, target, weekStart, localeName);
    }
    return (react.createElement(date, week_assign({}, rest, bodyProps, headerOperations, { isWeek: true, isSameTime: isSameTime, isRangePicker: isRangePicker })));
}
/* harmony default export */ var week = (WeekPicker);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/panels/quarter/index.js
var quarter_assign = (undefined && undefined.__assign) || function () {
    quarter_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return quarter_assign.apply(this, arguments);
};
var quarter_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};









function QuarterPicker(props) {
    var pageShowDate = props.pageShowDate, style = props.style, onMouseEnterCell = props.onMouseEnterCell, onMouseLeaveCell = props.onMouseLeaveCell, dateRender = props.dateRender, disabledDate = props.disabledDate, value = props.value, locale = props.locale, isRangePicker = props.isRangePicker, onSelect = props.onSelect, rangeValues = props.rangeValues, onSuperPrev = props.onSuperPrev, onSuperNext = props.onSuperNext, format = props.format, getHeaderOperations = props.getHeaderOperations, setPageShowDate = props.setPageShowDate, icons = props.icons, panelMode = props.panelMode, setPanelMode = props.setPanelMode, rest = quarter_rest(props, ["pageShowDate", "style", "onMouseEnterCell", "onMouseLeaveCell", "dateRender", "disabledDate", "value", "locale", "isRangePicker", "onSelect", "rangeValues", "onSuperPrev", "onSuperNext", "format", "getHeaderOperations", "setPageShowDate", "icons", "panelMode", "setPanelMode"]);
    var _a = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), globalLocale = _a.locale, getPrefixCls = _a.getPrefixCls, rtl = _a.rtl;
    var DATEPICKER_LOCALE = merge_default()(globalLocale.DatePicker, locale);
    var CALENDAR_LOCALE = DATEPICKER_LOCALE.Calendar;
    var prefixCls = getPrefixCls('panel-quarter');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls);
    var bodyProps = isRangePicker ? { rangeValues: rangeValues } : { value: value };
    var showYear = pageShowDate.year();
    var rows = [
        [1, 2, 3, 4].map(function (q) { return ({
            name: "Q" + q,
            time: (0,_util_dayjs/* dayjs */.Bv)(showYear + "-" + (0,pad/* padStart */.S)((q - 1) * 3 + 1, 2, '0') + "-01"),
        }); }),
    ];
    function renderCalendar() {
        return (react.createElement(body, quarter_assign({}, rest, bodyProps, { prefixCls: getPrefixCls('picker'), rows: rows, onSelectDate: onSelect, isSameTime: function (current, target) { return current.isSame(target, 'month'); }, onMouseEnterCell: onMouseEnterCell, onMouseLeaveCell: onMouseLeaveCell, dateRender: dateRender, disabledDate: disabledDate, CALENDAR_LOCALE: CALENDAR_LOCALE, mode: "quarter", format: format })));
    }
    var headerOperations = { onSuperPrev: onSuperPrev, onSuperNext: onSuperNext };
    function onChangePanel(mode) {
        setPanelMode(mode);
    }
    if (panelMode === 'year') {
        return (react.createElement(year, quarter_assign({}, getHeaderOperations(panelMode), { pageShowDate: pageShowDate, onSelect: function (_, date) {
                setPanelMode('quarter');
                setPageShowDate(date);
            }, disabledDate: disabledDate })));
    }
    return (react.createElement("div", { className: classNames, style: style },
        react.createElement(header, quarter_assign({}, headerOperations, { icons: icons, prefixCls: getPrefixCls('picker'), value: pageShowDate, mode: panelMode, onChangePanel: onChangePanel, rtl: rtl })),
        react.createElement("div", { className: prefixCls + "-wrapper" }, renderCalendar())));
}
/* harmony default export */ var quarter = (QuarterPicker);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/panels/range/index.js
var range_assign = (undefined && undefined.__assign) || function () {
    range_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return range_assign.apply(this, arguments);
};











function range(start, end) {
    var result = [];
    for (var i = start; i < end; i++) {
        result.push(i);
    }
    return result;
}
function RangePicker(props) {
    var _a = props.mode, mode = _a === void 0 ? 'date' : _a, showTime = props.showTime, disabledDate = props.disabledDate, disabledTime = props.disabledTime, format = props.format, dateRender = props.dateRender, propsValue = props.value, timeValues = props.timeValues, icons = props.icons, locale = props.locale, pageShowDates = props.pageShowDates, onMouseEnterCell = props.onMouseEnterCell, onMouseLeaveCell = props.onMouseLeaveCell, onSelectTime = props.onTimePickerSelect, onSelectPanel = props.onSelectPanel, onPrev = props.onPrev, onSuperPrev = props.onSuperPrev, onNext = props.onNext, onSuperNext = props.onSuperNext, localeName = props.localeName, popupVisible = props.popupVisible, timepickerProps = props.timepickerProps, getHeaderOperations = props.getHeaderOperations, setRangePageShowDates = props.setRangePageShowDates, disabledTimePickerIndex = props.disabledTimePickerIndex, hideNotInViewDates = props.hideNotInViewDates, isTimePanel = props.isTimePanel, valueShowHover = props.valueShowHover, panelModes = props.panelModes, setPanelModes = props.setPanelModes;
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var prefixCls = getPrefixCls('picker-range');
    var _b = (0,react.useContext)(DatePicker_context), utcOffset = _b.utcOffset, timezone = _b.timezone;
    var startShowDate = pageShowDates[0] || (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone);
    var endShowDate = pageShowDates[1] || (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone);
    var value = (0,_util_dayjs/* getDayjsValue */.p3)(propsValue, format);
    var basePickerProps = {
        isRangePicker: true,
        rangeValues: value,
        onMouseEnterCell: onMouseEnterCell,
        onMouseLeaveCell: onMouseLeaveCell,
        locale: locale,
        disabledDate: disabledDate,
        onSelect: onSelectPanel,
        dateRender: dateRender,
        getHeaderOperations: getHeaderOperations,
        icons: icons,
        valueShowHover: valueShowHover,
    };
    var startPickerProps = {
        pageShowDate: startShowDate,
        panelMode: panelModes[0],
        setPanelMode: function (m) { return setPanelModes([m, panelModes[1]]); },
        format: getFormatByIndex(format, 0),
    };
    var endPickerProps = {
        pageShowDate: endShowDate,
        panelMode: panelModes[1],
        setPanelMode: function (m) { return setPanelModes([panelModes[0], m]); },
        format: getFormatByIndex(format, 1),
    };
    function renderDate() {
        var startOperations = {
            onPrev: onPrev,
            onSuperPrev: onSuperPrev,
        };
        var endOperations = {
            onNext: onNext,
            onSuperNext: onSuperNext,
        };
        var pickerProps = range_assign(range_assign({}, basePickerProps), { localeName: localeName, popupVisible: popupVisible, timepickerProps: timepickerProps, getHeaderOperations: getHeaderOperations, hideNotInViewDates: hideNotInViewDates, isTimePanel: isTimePanel });
        if (mode === 'week') {
            return (react.createElement(react.Fragment, null,
                react.createElement(week, range_assign({ setPageShowDate: function (d) { return setRangePageShowDates([d, d], 0); } }, startOperations, pickerProps, startPickerProps)),
                react.createElement(week, range_assign({ setPageShowDate: function (d) { return setRangePageShowDates([_util_dayjs/* methods.subtract */.xB.subtract(d, 1, 'month'), d], 1); } }, endOperations, pickerProps, endPickerProps))));
        }
        var showTimeProps = {
            disabledTime: disabledTime,
            showTime: showTime,
        };
        var disabledTimePickerProps = {};
        // 禁用面板时，TimePicker 被整体禁用同时关闭 hideDisabledOptions 防止用户传 true 导致空白
        if (typeof disabledTimePickerIndex === 'number') {
            disabledTimePickerProps.disabledTime = function () { return ({
                disabledHours: function () { return range(0, 24); },
                disabledMinutes: function () { return range(0, 60); },
                disabledSeconds: function () { return range(0, 60); },
            }); };
            if ((0,is/* isObject */.Kn)(showTime)) {
                var st = range_assign(range_assign({}, showTime), { defaultValue: undefined });
                disabledTimePickerProps.showTime = range_assign(range_assign({}, st), { hideDisabledOptions: false });
            }
        }
        return (react.createElement(react.Fragment, null,
            react.createElement(date, range_assign({}, startOperations, pickerProps, showTimeProps, (disabledTimePickerIndex === 0 ? disabledTimePickerProps : {}), { onTimePickerSelect: function (timeString, time) {
                    onSelectTime(0, timeString, time);
                }, index: 0, setPageShowDate: function (d) { return setRangePageShowDates([d, d], 0); }, timeValue: timeValues[0] }, startPickerProps)),
            react.createElement(date, range_assign({}, endOperations, pickerProps, showTimeProps, (disabledTimePickerIndex === 1 ? disabledTimePickerProps : {}), { onTimePickerSelect: function (timeString, time) {
                    onSelectTime(1, timeString, time);
                }, index: 1, setPageShowDate: function (d) { return setRangePageShowDates([_util_dayjs/* methods.subtract */.xB.subtract(d, 1, 'month'), d], 1); }, timeValue: timeValues[1] }, endPickerProps))));
    }
    function renderMonth() {
        var startOperations = {
            onSuperPrev: onSuperPrev,
        };
        var endOperations = {
            onSuperNext: onSuperNext,
        };
        var pickerProps = basePickerProps;
        return (react.createElement(react.Fragment, null,
            react.createElement(month, range_assign({ setPageShowDate: function (d) { return setRangePageShowDates([d, d], 0); } }, startOperations, pickerProps, startPickerProps)),
            react.createElement(month, range_assign({ setPageShowDate: function (d) { return setRangePageShowDates([_util_dayjs/* methods.subtract */.xB.subtract(d, 1, 'year'), d], 1); } }, endOperations, pickerProps, endPickerProps))));
    }
    function renderYear() {
        var startOperations = {
            onSuperPrev: onSuperPrev,
        };
        var endOperations = {
            onSuperNext: onSuperNext,
        };
        var pickerProps = basePickerProps;
        return (react.createElement(react.Fragment, null,
            react.createElement(year, range_assign({}, startOperations, pickerProps, { pageShowDate: startShowDate })),
            react.createElement(year, range_assign({}, endOperations, pickerProps, { pageShowDate: endShowDate }))));
    }
    function renderQuarter() {
        var startOperations = {
            onSuperPrev: onSuperPrev,
        };
        var endOperations = {
            onSuperNext: onSuperNext,
        };
        var pickerProps = basePickerProps;
        return (react.createElement(react.Fragment, null,
            react.createElement(quarter, range_assign({ setPageShowDate: function (d) { return setRangePageShowDates([d, d], 0); } }, startOperations, pickerProps, startPickerProps)),
            react.createElement(quarter, range_assign({ setPageShowDate: function (d) { return setRangePageShowDates([_util_dayjs/* methods.subtract */.xB.subtract(d, 1, 'year'), d], 1); } }, endOperations, pickerProps, endPickerProps))));
    }
    return (react.createElement("div", { className: prefixCls },
        react.createElement("div", { className: prefixCls + "-wrapper" },
            (mode === 'date' || mode === 'week') && renderDate(),
            mode === 'month' && renderMonth(),
            mode === 'year' && renderYear(),
            mode === 'quarter' && renderQuarter())));
}
/* harmony default export */ var panels_range = (RangePicker);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/picker-range.js
var picker_range_assign = (undefined && undefined.__assign) || function () {
    picker_range_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return picker_range_assign.apply(this, arguments);
};
var picker_range_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var picker_range_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};


















// get default format by mode
function picker_range_getFormat(props) {
    var format = props.format, showTime = props.showTime, mode = props.mode;
    var valueFormat;
    switch (mode) {
        case 'date':
            valueFormat = showTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
            break;
        case 'month':
            valueFormat = 'YYYY-MM';
            break;
        case 'year':
            valueFormat = 'YYYY';
            break;
        case 'week':
            valueFormat = 'YYYY-wo';
            break;
        case 'quarter':
            valueFormat = 'YYYY-[Q]Q';
            break;
        default:
            valueFormat = 'YYYY-MM-DD';
    }
    if (format) {
        valueFormat = format;
    }
    return valueFormat;
}
var picker_range_defaultProps = {
    allowClear: true,
    unmountOnExit: true,
    position: 'bl',
    editable: true,
    mode: 'date',
};
var picker_range_triggerPopupAlign = { bottom: 4 };
var picker_range_Picker = function (baseProps) {
    var _a, _b;
    var _c = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _c.getPrefixCls, locale = _c.locale, ctxSize = _c.size, componentConfig = _c.componentConfig, rtl = _c.rtl;
    if (rtl) {
        picker_range_defaultProps.position = 'br';
    }
    var props = (0,useMergeProps/* default */.Z)(baseProps, picker_range_defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.DatePicker);
    var allowClear = props.allowClear, className = props.className, style = props.style, placeholder = props.placeholder, getPopupContainer = props.getPopupContainer, disabled = props.disabled, position = props.position, error = props.error, status = props.status, unmountOnExit = props.unmountOnExit, editable = props.editable, triggerProps = props.triggerProps, shortcuts = props.shortcuts, onSelect = props.onSelect, onVisibleChange = props.onVisibleChange, propsValue = props.value, onChange = props.onChange, icons = props.icons, disabledDate = props.disabledDate, disabledTime = props.disabledTime, mode = props.mode, showTime = props.showTime, onSelectShortcut = props.onSelectShortcut, extra = props.extra, shortcutsPlacementLeft = props.shortcutsPlacementLeft, onOk = props.onOk, defaultPickerValue = props.defaultPickerValue, pickerValue = props.pickerValue, panelRender = props.panelRender, onPickerValueChange = props.onPickerValueChange, triggerElement = props.triggerElement, clearRangeOnReselect = props.clearRangeOnReselect, separator = props.separator, utcOffset = props.utcOffset, timezone = props.timezone;
    var prefixCls = getPrefixCls('picker-range');
    var weekStart = (0,is/* isUndefined */.o8)(props.dayStartOfWeek)
        ? getDefaultWeekStart(locale.dayjsLocale)
        : props.dayStartOfWeek;
    var refInput = (0,react.useRef)(null);
    var refPanel = (0,react.useRef)(null);
    var refShortcuts = (0,react.useRef)(null);
    var shortcutEnterTimer = (0,react.useRef)(null);
    var shortcutLeaveTimer = (0,react.useRef)(null);
    var format = picker_range_getFormat(props);
    // get input index when half disabled
    function getAvailableInputIndex() {
        if ((0,is/* isArray */.kJ)(disabled)) {
            if (disabled[0] && !disabled[1]) {
                return 1;
            }
            if (disabled[1] && !disabled[0]) {
                return 0;
            }
        }
    }
    var availableInputIndex = getAvailableInputIndex();
    var isHalfAvailable = typeof availableInputIndex === 'number';
    var disabledTimePickerIndex = isHalfAvailable ? 1 ^ availableInputIndex : undefined;
    // current focus index
    var _d = picker_range_read((0,react.useState)(isHalfAvailable ? availableInputIndex : 0), 2), focusedInputIndex = _d[0], setFocusedInputIndex = _d[1];
    (0,react.useEffect)(function () {
        if (isHalfAvailable) {
            setFocusedInputIndex(availableInputIndex);
        }
    }, [disabled]);
    var nextFocusedInputIndex = 1 ^ focusedInputIndex;
    var _e = picker_range_read((0,react.useState)(), 2), inputValue = _e[0], setInputValue = _e[1];
    var _f = picker_range_read((0,react.useState)(), 2), hoverPlaceholderValue = _f[0], setHoverPlaceholderValue = _f[1];
    var _g = picker_range_read((0,react.useState)(getDefaultValue()), 2), value = _g[0], setValue = _g[1];
    var _h = picker_range_read((0,react.useState)(), 2), valueShow = _h[0], setValueShow = _h[1];
    var _j = picker_range_read((0,react.useState)(), 2), valueShowHover = _j[0], setValueShowHover = _j[1];
    var _k = picker_range_read((0,react.useState)(), 2), shortcutsValue = _k[0], setShortcutsValue = _k[1];
    var _l = picker_range_read((0,react.useState)(props.popupVisible), 2), popupVisible = _l[0], setPopupVisible = _l[1];
    var _m = picker_range_read((0,react.useState)([mode, mode]), 2), panelModes = _m[0], setPanelModes = _m[1];
    var _o = picker_range_read((0,react.useState)(false), 2), isTimePanel = _o[0], setIsTimePanel = _o[1];
    var mergedPopupVisible = 'popupVisible' in props ? props.popupVisible : popupVisible;
    var propsValueDayjs = (0,_util_dayjs/* getDayjsValue */.p3)(propsValue, format, utcOffset, timezone);
    var mergedValue = 'value' in props ? propsValueDayjs : value;
    var panelValue = shortcutsValue || valueShow || mergedValue || [];
    var selectedLength = getAvailableDayjsLength(valueShow || mergedValue);
    // the first time we select a range after open
    var firstRange = (0,react.useRef)(true);
    var now = (0,_util_dayjs/* getNow */.Iz)();
    var zoneNow = (0,_util_dayjs/* toTimezone */.xp)(now, utcOffset, timezone);
    function getTimeValues() {
        var timeValues = [];
        var defaultTimeValue = (0,is/* isObject */.Kn)(showTime) && showTime.defaultValue
            ? (0,_util_dayjs/* getDayjsValue */.p3)(showTime.defaultValue, showTime.format || 'HH:mm:ss')
            : [];
        timeValues[0] = panelValue[0] || defaultTimeValue[0] || zoneNow;
        timeValues[1] = panelValue[1] || defaultTimeValue[1] || zoneNow;
        return timeValues;
    }
    var timeValues = getTimeValues();
    var selectedDisabledDate = isHalfAvailable
        ? function (current) {
            return availableInputIndex === 0
                ? current.isAfter(panelValue[1], mode)
                : current.isBefore(panelValue[0], mode);
        }
        : undefined;
    // if triggerElement !== undefined, we should activate clearRangeOnReselect by default
    var customTriggerElement = triggerElement !== undefined;
    var resetRange = customTriggerElement || clearRangeOnReselect;
    function getDefaultValue() {
        var value;
        if (props.value) {
            value = (0,_util_dayjs/* getDayjsValue */.p3)(props.value, format, utcOffset, timezone);
        }
        else {
            value = (0,_util_dayjs/* getDayjsValue */.p3)(props.defaultValue, format, utcOffset, timezone);
        }
        if (isHalfAvailable && (!value || (value && !value[nextFocusedInputIndex]))) {
            var nv = [];
            nv[nextFocusedInputIndex] = (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone);
            return nv;
        }
        return value;
    }
    var defaultPageShowDates = mergedValue ||
        (0,_util_dayjs/* getDayjsValue */.p3)(defaultPickerValue, format) || [now, now];
    // show date at two panels
    var _p = picker_range_read((0,react.useState)(getShowDatesFromFocused(defaultPageShowDates)), 2), pageShowDates = _p[0], setPageShowDates = _p[1];
    var mergedPageShowDate = getShowDatesFromFocused((0,_util_dayjs/* getDayjsValue */.p3)(pickerValue, format, utcOffset, timezone)) ||
        pageShowDates;
    var previousUtcOffset = (0,usePrevious/* default */.Z)(utcOffset);
    var previousTimezone = (0,usePrevious/* default */.Z)(timezone);
    // when timezone or utcOffset change changed
    (0,useUpdate/* default */.Z)(function () {
        if ((0,is/* isArray */.kJ)(value) && (previousUtcOffset !== utcOffset || timezone !== previousTimezone)) {
            var localValue = value.map(function (v) { return (0,_util_dayjs/* toLocal */.sB)(v, previousUtcOffset, previousTimezone); });
            var zoneValue = localValue.map(function (v) { return (0,_util_dayjs/* toTimezone */.xp)(v, utcOffset, timezone); });
            setValue(zoneValue);
        }
    }, [utcOffset, previousUtcOffset, timezone, previousTimezone]);
    // panel open and change mode
    (0,useUpdate/* default */.Z)(function () {
        setPageShowDates(getShowDatesFromFocused(defaultPageShowDates));
    }, [mode]);
    (0,react.useEffect)(function () {
        setPanelModes([mode, mode]);
    }, [mode]);
    (0,react.useEffect)(function () {
        setHoverPlaceholderValue(undefined);
        setInputValue(undefined);
        if (mergedPopupVisible) {
            var resetPageShowDates = getShowDatesFromFocused(defaultPageShowDates);
            setIsTimePanel(false);
            setPanelModes([mode, mode]);
            setPageShowDates(resetPageShowDates);
            handlePickerValueChange(resetPageShowDates);
            setValueShow(mergedValue);
            if (shortcutsPlacementLeft) {
                refShortcuts.current.style.maxHeight = refPanel.current.clientHeight + "px";
            }
        }
        else {
            setValueShow(undefined);
            setValueShowHover(undefined);
            setShortcutsValue(undefined);
            blurInput();
        }
        firstRange.current = mergedPopupVisible;
    }, [mergedPopupVisible]);
    var startStr = (_a = propsValueDayjs === null || propsValueDayjs === void 0 ? void 0 : propsValueDayjs[0]) === null || _a === void 0 ? void 0 : _a.format(getFormatByIndex(format, 0));
    var endStr = (_b = propsValueDayjs === null || propsValueDayjs === void 0 ? void 0 : propsValueDayjs[1]) === null || _b === void 0 ? void 0 : _b.format(getFormatByIndex(format, 1));
    (0,react.useEffect)(function () {
        setValueShow(undefined);
        setValueShowHover(undefined);
    }, [startStr, endStr]);
    function setFixedPageShowDates(innerValue, index) {
        if (index === void 0) { index = focusedInputIndex; }
        var newPageShowDates = getShowDatesFromFocused(innerValue, index);
        setPageShowDates(newPageShowDates);
        handlePickerValueChange(newPageShowDates);
    }
    function handlePickerValueChange(v) {
        if (!isSamePanel([v[0], pageShowDates[0]], mode)) {
            onPickerValueChange &&
                onPickerValueChange((0,is/* isArray */.kJ)(v) ? v.map(function (v, i) { return v && v.format(getFormatByIndex(format, i)); }) : undefined, v);
        }
    }
    function getShowDatesFromFocused(dates, index) {
        if (index === void 0) { index = focusedInputIndex; }
        var prev = index === 0 || isSamePanel(dates, mode);
        if ((0,is/* isArray */.kJ)(dates) && dates.length < 2) {
            return getPageShowDatesByValue(dates[0] || (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone), mode, 'prev');
        }
        if ((0,is/* isArray */.kJ)(dates) && dates.length === 2) {
            if (dates[index]) {
                return getPageShowDatesByValue(dates[index], mode, prev ? 'prev' : 'next');
            }
            return getPageShowDatesByValue(dates[index === 0 ? 1 : 0] || (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone), mode, prev && !dates[index === 0 ? 1 : 0] ? 'prev' : 'next');
        }
    }
    function isSamePanel(innerValue, pickerMode) {
        if (innerValue && innerValue.length === 2 && isValidDayjsArray(innerValue)) {
            return (((pickerMode === 'date' || pickerMode === 'week') &&
                innerValue[0].isSame(innerValue[1], 'month')) ||
                ((pickerMode === 'month' || pickerMode === 'quarter') &&
                    innerValue[0].isSame(innerValue[1], 'year')) ||
                (pickerMode === 'year' &&
                    Math.floor(innerValue[0].year() / 10) === Math.floor(innerValue[1].year() / 10)));
        }
    }
    // get page show date by specify value
    function getPageShowDatesByValue(value, pickerMode, type) {
        if (value === void 0) { value = (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone); }
        if (pickerMode === void 0) { pickerMode = mode; }
        if (type === void 0) { type = 'prev'; }
        var prev = type === 'prev';
        switch (pickerMode) {
            case 'date':
            case 'week':
                return prev
                    ? [value, _util_dayjs/* methods.add */.xB.add(value, 1, 'month')]
                    : [_util_dayjs/* methods.subtract */.xB.subtract(value, 1, 'month'), value];
            case 'month':
            case 'quarter':
                return prev
                    ? [value, _util_dayjs/* methods.add */.xB.add(value, 1, 'year')]
                    : [_util_dayjs/* methods.subtract */.xB.subtract(value, 1, 'year'), value];
            case 'year':
                return prev
                    ? [value, _util_dayjs/* methods.add */.xB.add(value, 10, 'year')]
                    : [_util_dayjs/* methods.subtract */.xB.subtract(value, 10, 'year'), value];
            default:
                return [];
        }
    }
    function focusInput(index) {
        refInput.current &&
            refInput.current.focus &&
            refInput.current.focus(isHalfAvailable ? availableInputIndex : index);
    }
    function blurInput() {
        refInput.current && refInput.current.blur && refInput.current.blur();
    }
    function visibleChange(visible) {
        if (visible) {
            setTimeout(function () { return focusInput(); });
            setOpen(visible);
        }
        else {
            setOpen(false);
        }
    }
    // open or close popup
    function setOpen(visible) {
        onVisibleChange && onVisibleChange(visible);
        setPopupVisible(visible);
    }
    function onClear(e) {
        e.stopPropagation();
        var newValueShow = picker_range_spreadArray([], picker_range_read(panelValue), false);
        if (isHalfAvailable) {
            newValueShow[availableInputIndex] = undefined;
        }
        else {
            newValueShow = undefined;
        }
        setValue(newValueShow);
        setValueShow(newValueShow);
        onHandleChange(newValueShow);
        props.onClear && props.onClear();
    }
    function changeFocusedInputIndex(index, silent) {
        setInputValue(undefined);
        setFocusedInputIndex(index);
        if (panelValue && panelValue.length && !silent) {
            var newPageShowDates = getShowDatesFromFocused(panelValue, index);
            setPageShowDates(newPageShowDates);
            handlePickerValueChange(newPageShowDates);
        }
    }
    function isDisabledDate(date) {
        var selectedDisabled = typeof selectedDisabledDate === 'function' ? selectedDisabledDate(date) : false;
        var originDisabledDate = typeof disabledDate === 'function' ? disabledDate(date) : false;
        return originDisabledDate || selectedDisabled;
    }
    // Determine whether the input date is in the correct format
    function isValid(time) {
        return ((0,_util_dayjs/* isValidTimeString */.OB)(time, format, focusedInputIndex) &&
            !isDisabledDate((0,_util_dayjs/* getDayjsValue */.p3)(time, format))
        // (panelValue[nextFocusedInputIndex]
        //   ? nextFocusedInputIndex === 0
        //     ? panelValue[nextFocusedInputIndex].isBefore(dayjs(time, format))
        //     : panelValue[nextFocusedInputIndex].isAfter(dayjs(time, format))
        //   : true)
        );
    }
    function onChangeInput(e) {
        var newValueShow = picker_range_spreadArray([], picker_range_read((panelValue || [])), false);
        var niv = e.target.value;
        setInputValue(niv);
        if (!mergedPopupVisible) {
            setOpen(true);
        }
        if (isValid(niv)) {
            newValueShow[focusedInputIndex] = (0,_util_dayjs/* getDayjsValue */.p3)(niv, format);
            setValueShow(newValueShow);
            setFixedPageShowDates(newValueShow);
            setInputValue(undefined);
        }
    }
    // Compare with the last value, trigger onChange only if the value changes
    function onHandleChange(newValue) {
        if ((0,_util_dayjs/* isDayjsArrayChange */.qF)(mergedValue, newValue)) {
            var localValue = (0,is/* isArray */.kJ)(newValue)
                ? newValue.map(function (v) {
                    return getLocaleDayjsValue((0,_util_dayjs/* toLocal */.sB)(v, utcOffset, timezone), locale.dayjsLocale);
                })
                : undefined;
            onChange &&
                onChange((0,is/* isArray */.kJ)(localValue)
                    ? localValue.map(function (v, i) { return v && v.format(getFormatByIndex(format, i)); })
                    : undefined, localValue);
        }
    }
    function onPressEnter() {
        if ((0,is/* isArray */.kJ)(valueShow) && valueShow.length) {
            if (inputValue && !isValid(inputValue)) {
                setInputValue(undefined);
            }
            else if (selectedLength !== 2) {
                switchFocusedInput();
            }
            else if (selectedLength === 2) {
                onConfirmValue(valueShow);
            }
        }
        else if (mergedPopupVisible) {
            setOpen(false);
        }
    }
    // Confirm and update component value
    function onConfirmValue(date, keepOpen) {
        var confirmValue = date || panelValue;
        if (!confirmValue || !confirmValue[0] || !confirmValue[1]) {
            return;
        }
        var sortedValues = (0,_util_dayjs/* getSortedDayjsArray */.ul)(confirmValue);
        setValue(sortedValues);
        onHandleChange(sortedValues);
        if (triggerElement !== null && !keepOpen) {
            setOpen(false);
        }
    }
    // Callback when click the confirm button
    function onClickConfirmBtn() {
        onConfirmValue();
        var localePanelValue = panelValue.map(function (v) { return getLocaleDayjsValue(v, locale.dayjsLocale); });
        onOk &&
            onOk(localePanelValue.map(function (v, i) { return v && v.format(getFormatByIndex(format, i)); }), localePanelValue);
    }
    function getUnit() {
        switch (mode) {
            case 'date':
            case 'week':
                return 'date';
            case 'month':
                return 'month';
            case 'year':
                return 'year';
            default:
                return undefined;
        }
    }
    function outOfRange(date) {
        if (selectedLength !== 2) {
            return false;
        }
        var v = valueShow || mergedValue;
        if (focusedInputIndex === 0 && date.isAfter(v[1], getUnit())) {
            return true;
        }
        if (focusedInputIndex === 1 && date.isBefore(v[0], getUnit())) {
            return true;
        }
        return false;
    }
    // Callback when click the panel date cell
    function onSelectPanel(_, date) {
        var isOutOfRange = outOfRange(date) && firstRange.current;
        var newValueShow = resetRange && selectedLength === 2 && !isHalfAvailable ? [] : picker_range_spreadArray([], picker_range_read(panelValue), false);
        // if custom triggerElement, focused input index always 0 -> 1
        var focusedIndex = customTriggerElement
            ? selectedLength === 0 || selectedLength === 2
                ? 0
                : 1
            : focusedInputIndex;
        var newDate = showTime ? (0,_util_dayjs/* getValueWithTime */.zr)(date, timeValues[focusedIndex]) : date;
        if (isOutOfRange) {
            newValueShow[focusedIndex] = newDate;
            newValueShow[1 ^ focusedIndex] = undefined;
        }
        else {
            newValueShow[focusedIndex] = newDate;
        }
        var sortedValueShow = (0,_util_dayjs/* getSortedDayjsArray */.ul)(newValueShow);
        onSelectValueShow(sortedValueShow);
        setInputValue(undefined);
        setHoverPlaceholderValue(undefined);
        var newSelectedLength = getAvailableDayjsLength(newValueShow);
        if (resetRange) {
            if (selectedLength === 0 || (selectedLength === 2 && !isHalfAvailable)) {
                customTriggerElement ? setFocusedInputIndex(1) : switchFocusedInput(true);
            }
            else if (!showTime) {
                onConfirmValue(newValueShow);
            }
        }
        else if (newSelectedLength <= 1) {
            switchFocusedInput(true);
        }
        else if (selectedLength === 2 && firstRange.current && !isHalfAvailable) {
            firstRange.current = false;
            switchFocusedInput(true);
            if (!showTime && !isOutOfRange) {
                onConfirmValue(newValueShow, true);
            }
        }
        else {
            firstRange.current = false;
            if (!showTime && !isOutOfRange) {
                onConfirmValue(newValueShow);
            }
        }
    }
    // Callback when click TimePicker
    function onTimePickerSelect(index, _, time) {
        var newValueShow = (0,is/* isArray */.kJ)(panelValue) ? picker_range_spreadArray([], picker_range_read(panelValue), false) : [];
        var newTimeValue = (0,_util_dayjs/* getValueWithTime */.zr)(newValueShow[index] || (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone), time);
        newValueShow[index] = newTimeValue;
        onSelectValueShow(newValueShow);
    }
    function onSelectValueShow(newValueShow) {
        setValueShow(newValueShow);
        setValueShowHover(undefined);
        var sortedValues = (0,_util_dayjs/* getSortedDayjsArray */.ul)(newValueShow);
        var zoneValues = sortedValues.map(function (v) {
            return getLocaleDayjsValue((0,_util_dayjs/* toLocal */.sB)(v, utcOffset, timezone), locale.dayjsLocale);
        });
        onSelect &&
            onSelect(zoneValues.map(function (v, i) { return v && v.format(getFormatByIndex(format, i)); }), zoneValues, { type: focusedInputIndex === 1 ? 'end' : 'start' });
    }
    // Switch to next focused input
    function switchFocusedInput(silent) {
        changeFocusedInputIndex(nextFocusedInputIndex, silent);
        setTimeout(function () { return focusInput(nextFocusedInputIndex); });
    }
    // Callback when mouse entered the date cell
    function onMouseEnterCell(date, disabled) {
        var newValueShowHover = picker_range_spreadArray([], picker_range_read((panelValue || [])), false);
        var needShowHover = resetRange ? selectedLength === 1 : selectedLength !== 0;
        if (!disabled && needShowHover && !outOfRange(date)) {
            newValueShowHover[focusedInputIndex] = (0,_util_dayjs/* getValueWithTime */.zr)(date, timeValues[focusedInputIndex]);
            setValueShowHover(newValueShowHover);
            setInputValue(undefined);
        }
        if (!disabled) {
            var placeHolderValue = showTime
                ? (0,_util_dayjs/* getValueWithTime */.zr)(date, timeValues[focusedInputIndex])
                : date;
            setHoverPlaceholderValue(placeHolderValue
                .locale(locale.dayjsLocale)
                .format(getFormatByIndex(format, focusedInputIndex)));
        }
    }
    function onMouseLeaveCell() {
        setValueShowHover(undefined);
        setHoverPlaceholderValue(undefined);
    }
    function isValidDayjsArray(sv) {
        return sv && (0,is/* isArray */.kJ)(sv) && sv.length === 2 && (0,is/* isDayjs */.qE)(sv[0]) && (0,is/* isDayjs */.qE)(sv[1]);
    }
    // Determine whether the value entered in the shortcut is in the correct format
    function isValidShortcut(shortcut) {
        var sv = typeof shortcut.value === 'function' && shortcut.value();
        return isValidDayjsArray(sv);
    }
    function clearShortcutsTimer() {
        clearTimeout(shortcutEnterTimer.current);
        clearTimeout(shortcutLeaveTimer.current);
        shortcutEnterTimer.current = null;
        shortcutLeaveTimer.current = null;
    }
    // Callback when mouse entered the shortcuts
    function onMouseEnterShortcut(shortcut) {
        clearShortcutsTimer();
        shortcutEnterTimer.current = setTimeout(function () {
            if (isValidShortcut(shortcut)) {
                var nv = (0,_util_dayjs/* getDayjsValue */.p3)(shortcut.value(), format, utcOffset, timezone);
                setShortcutsValue(nv);
                setFixedPageShowDates(nv);
            }
        }, 50);
    }
    // Callback when mouse leaved the shortcuts
    function onMouseLeaveShortcut() {
        clearShortcutsTimer();
        shortcutLeaveTimer.current = setTimeout(function () {
            setShortcutsValue(undefined);
            setFixedPageShowDates(valueShow || mergedValue || [(0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone), (0,_util_dayjs/* getNow */.Iz)(utcOffset, timezone)]);
        }, 50);
    }
    // Callback when click the shortcuts button
    function onHandleSelectShortcut(shortcut) {
        onSelectShortcut && onSelectShortcut(shortcut);
        if (isValidShortcut(shortcut)) {
            var time = (0,_util_dayjs/* getDayjsValue */.p3)(shortcut.value(), format, utcOffset, timezone);
            onConfirmValue(time);
        }
    }
    // Modify panel date (the value of the panel itself, not the component value)
    function changePageShowDates(type, unit, num) {
        if (num === void 0) { num = 1; }
        var index = type === 'prev' ? 0 : 1;
        var newPageShowDates = picker_range_spreadArray([], picker_range_read(mergedPageShowDate), false);
        if (type === 'prev') {
            newPageShowDates[index] = _util_dayjs/* methods.subtract */.xB.subtract(mergedPageShowDate[index], num, unit);
        }
        if (type === 'next') {
            newPageShowDates[index] = _util_dayjs/* methods.add */.xB.add(mergedPageShowDate[index], num, unit);
        }
        newPageShowDates = getPageShowDatesByValue(newPageShowDates[index], mode, type);
        setFixedPageShowDates(newPageShowDates);
    }
    // Callback when click the prev or next button
    function getHeaderOperations(pickerMode) {
        if (pickerMode === void 0) { pickerMode = mode; }
        if (pickerMode === 'date' || pickerMode === 'week') {
            return {
                onPrev: function () { return changePageShowDates('prev', 'month'); },
                onNext: function () { return changePageShowDates('next', 'month'); },
                onSuperPrev: function () { return changePageShowDates('prev', 'year'); },
                onSuperNext: function () { return changePageShowDates('next', 'year'); },
            };
        }
        if (pickerMode === 'month' || pickerMode === 'quarter') {
            return {
                onSuperPrev: function () { return changePageShowDates('prev', 'year'); },
                onSuperNext: function () { return changePageShowDates('next', 'year'); },
            };
        }
        if (pickerMode === 'year') {
            return {
                onSuperPrev: function () { return changePageShowDates('prev', 'year', 10); },
                onSuperNext: function () { return changePageShowDates('next', 'year', 10); },
            };
        }
    }
    function onClickSelectTimeBtn() {
        setIsTimePanel(!isTimePanel);
    }
    function renderPopup(panelOnly) {
        var _a;
        var classNames = (0,_util_classNames/* default */.Z)(prefixCls + "-container", (_a = {},
            _a[prefixCls + "-panel-only"] = panelOnly,
            _a[prefixCls + "-container-shortcuts-placement-left"] = (0,is/* isArray */.kJ)(shortcuts) && shortcutsPlacementLeft,
            _a[prefixCls + "-container-rtl"] = rtl,
            _a), panelOnly ? className : '');
        var shortcutsProps = {
            prefixCls: getPrefixCls('picker'),
            showTime: showTime,
            shortcuts: shortcuts,
            onMouseEnterShortcut: onMouseEnterShortcut,
            onMouseLeaveShortcut: onMouseLeaveShortcut,
            onSelectShortcut: onHandleSelectShortcut,
        };
        var shouldShowFooter = (showTime && panelModes[0] === 'date' && panelModes[1] === 'date') ||
            extra ||
            ((0,is/* isArray */.kJ)(shortcuts) && shortcuts.length && !shortcutsPlacementLeft);
        var content = (react.createElement(react.Fragment, null,
            react.createElement(panels_range, picker_range_assign({}, props, getHeaderOperations(), { getHeaderOperations: getHeaderOperations, setRangePageShowDates: setFixedPageShowDates, pageShowDates: mergedPageShowDate, value: panelValue, format: format, onSelectPanel: onSelectPanel, onMouseEnterCell: onMouseEnterCell, onMouseLeaveCell: onMouseLeaveCell, disabledDate: function (current) { return isDisabledDate(current); }, disabledTime: disabledTime, mode: mode, localeName: locale.dayjsLocale, showTime: showTime, timeValues: shortcutsValue || timeValues, onTimePickerSelect: onTimePickerSelect, popupVisible: mergedPopupVisible, disabledTimePickerIndex: disabledTimePickerIndex, isTimePanel: isTimePanel, valueShowHover: valueShowHover, panelModes: panelModes, setPanelModes: setPanelModes })),
            !!shouldShowFooter && (react.createElement(Footer, picker_range_assign({}, shortcutsProps, { DATEPICKER_LOCALE: locale.DatePicker, disabled: !((0,is/* isArray */.kJ)(panelValue) && panelValue[0] && panelValue[1]), onClickConfirmBtn: onClickConfirmBtn, extra: extra, shortcutsPlacementLeft: shortcutsPlacementLeft, onClickSelectTimeBtn: onClickSelectTimeBtn, isTimePanel: isTimePanel })))));
        var contentWithShortcuts = shortcutsPlacementLeft ? (react.createElement(react.Fragment, null,
            react.createElement(panels_shortcuts, picker_range_assign({ ref: refShortcuts }, shortcutsProps)),
            react.createElement("div", { ref: refPanel, className: prefixCls + "-panel-wrapper" }, content))) : (content);
        var panelNode = typeof panelRender === 'function' ? panelRender(contentWithShortcuts) : contentWithShortcuts;
        return (react.createElement("div", { className: classNames, onClick: function () { return focusInput(); }, style: panelOnly ? style : {} }, panelNode));
    }
    var size = props.size || ctxSize;
    var placeholders = (0,is/* isArray */.kJ)(placeholder) ? placeholder : locale.DatePicker.placeholders[mode];
    var suffixIcon = icons && icons.inputSuffix === null
        ? null
        : (icons && icons.inputSuffix) || (showTime ? react.createElement(react_icon_IconCalendarClock, null) : react.createElement(IconCalendar/* default */.Z, null));
    var baseInputProps = {
        style: style,
        className: className,
        popupVisible: mergedPopupVisible,
        format: format,
        disabled: disabled,
        error: error,
        status: status,
        size: size,
        onPressEnter: onPressEnter,
        onClear: onClear,
        suffixIcon: suffixIcon,
        editable: editable,
        allowClear: allowClear,
        prefix: props.prefix,
    };
    var triggerDisabled = (0,is/* isArray */.kJ)(disabled) ? disabled[0] && disabled[1] : disabled;
    return (react.createElement(DatePicker_context.Provider, { value: { utcOffset: utcOffset, timezone: timezone, weekStart: weekStart } }, triggerElement === null ? (renderPopup(true)) : (react.createElement(Trigger/* default */.Z, picker_range_assign({ popup: renderPopup, trigger: "click", clickToClose: false, position: position, disabled: triggerDisabled, popupAlign: picker_range_triggerPopupAlign, getPopupContainer: getPopupContainer, onVisibleChange: visibleChange, popupVisible: mergedPopupVisible, classNames: "slideDynamicOrigin", unmountOnExit: unmountOnExit }, triggerProps), triggerElement || (react.createElement(input_range, picker_range_assign({}, (0,pick/* pickDataAttributes */.m)(props), baseInputProps, { ref: refInput, placeholder: placeholders, value: valueShow || mergedValue, onChange: onChangeInput, inputValue: hoverPlaceholderValue || inputValue, changeFocusedInputIndex: changeFocusedInputIndex, focusedInputIndex: focusedInputIndex, isPlaceholder: !!hoverPlaceholderValue, separator: separator })))))));
};
picker_range_Picker.displayName = 'RangePicker';
/* harmony default export */ var picker_range = (picker_range_Picker);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/DatePicker/index.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var DatePicker_assign = (undefined && undefined.__assign) || function () {
    DatePicker_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return DatePicker_assign.apply(this, arguments);
};








function wrapper(picker, options) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(PickerWrapper, _super);
            function PickerWrapper() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            PickerWrapper.prototype.render = function () {
                return react.createElement(DatePicker_picker, DatePicker_assign({}, this.props, { picker: picker, mode: options.mode }));
            };
            return PickerWrapper;
        }(react.Component)),
        _a.displayName = options.displayName,
        _a;
}
var DatePicker_DatePicker = wrapper(react.createElement(date, null), {
    displayName: 'DatePicker',
    mode: 'date',
});
var DatePicker_MonthPicker = wrapper(react.createElement(month, null), {
    displayName: 'MonthPicker',
    mode: 'month',
});
var DatePicker_YearPicker = wrapper(react.createElement(year, null), {
    displayName: 'YearPicker',
    mode: 'year',
});
var DatePicker_WeekPicker = wrapper(react.createElement(week, null), {
    displayName: 'WeekPicker',
    mode: 'week',
});
var DatePicker_QuarterPicker = wrapper(react.createElement(quarter, null), {
    displayName: 'QuarterPicker',
    mode: 'quarter',
});
var DatePicker_RangePicker = picker_range;
Object.assign(DatePicker_DatePicker, { MonthPicker: DatePicker_MonthPicker, YearPicker: DatePicker_YearPicker, WeekPicker: DatePicker_WeekPicker, QuarterPicker: DatePicker_QuarterPicker, RangePicker: DatePicker_RangePicker });
/* harmony default export */ var es_DatePicker = (DatePicker_DatePicker);


/***/ }),

/***/ 12106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _icon_react_icon_IconLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72297);
/* harmony import */ var _util_classNames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34855);
/* harmony import */ var _ConfigProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32393);
/* harmony import */ var _util_hooks_useMergeProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92833);
/* harmony import */ var _util_hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57483);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};






var defaultProps = {
    hoverable: true,
};
function Link(baseProps, ref) {
    var _a;
    var _b = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_ConfigProvider__WEBPACK_IMPORTED_MODULE_1__/* .ConfigContext */ .E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,_util_hooks_useMergeProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Link);
    var className = props.className, style = props.style, children = props.children, icon = props.icon, status = props.status, disabled = props.disabled, hoverable = props.hoverable, rest = __rest(props, ["className", "style", "children", "icon", "status", "disabled", "hoverable"]);
    var getKeyboardEvents = (0,_util_hooks_useKeyboardEvent__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({ onKeyDown: props.onKeyDown });
    var prefixCls = getPrefixCls('link');
    var TagWrapper = 'href' in props ? 'a' : 'span';
    var handleClick = function (e) {
        if (disabled) {
            e.preventDefault();
            e.stopPropagation();
        }
        else {
            props.onClick && props.onClick(e);
        }
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(TagWrapper, __assign({ className: (0,_util_classNames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(prefixCls, (_a = {},
            _a[prefixCls + "-disabled"] = disabled,
            _a[prefixCls + "-is-" + status] = status,
            _a[prefixCls + "-with-icon"] = icon,
            _a[prefixCls + "-hoverless"] = !hoverable,
            _a[prefixCls + "-rtl"] = rtl,
            _a), className), ref: ref, tabIndex: disabled ? -1 : undefined }, rest, { style: style, onClick: handleClick }, getKeyboardEvents({
        onPressEnter: handleClick,
    })),
        icon ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: prefixCls + "-icon" }, icon === true ? react__WEBPACK_IMPORTED_MODULE_0__.createElement(_icon_react_icon_IconLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, null) : icon)) : null,
        children));
}
var LinkRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(Link);
LinkRef.displayName = 'Link';
/* harmony default export */ __webpack_exports__["Z"] = (LinkRef);


/***/ }),

/***/ 89671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconCalendarComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-calendar")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    d: "M7 22h34M14 5v8m20-8v8M8 41h32a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1Z"
  }));
}

var IconCalendar = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconCalendarComponent);
IconCalendar.defaultProps = {
  isIcon: true
};
IconCalendar.displayName = 'IconCalendar';
/* harmony default export */ __webpack_exports__["Z"] = (IconCalendar);

/***/ }),

/***/ 27638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconDoubleRightComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-double-right")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    d: "m11.143 38.1 14.142-14.142L11.143 9.816M22.456 38.1l14.142-14.142L22.456 9.816"
  }));
}

var IconDoubleRight = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconDoubleRightComponent);
IconDoubleRight.defaultProps = {
  isIcon: true
};
IconDoubleRight.displayName = 'IconDoubleRight';
/* harmony default export */ __webpack_exports__["Z"] = (IconDoubleRight);

/***/ }),

/***/ 88101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconGiftComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-gift")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    d: "M13.45 14.043H8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h32a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-4.893m-21.657 0c-1.036-2.833-.615-5.6 1.182-6.637 2.152-1.243 5.464.464 7.397 3.812.539.933.914 1.896 1.127 2.825m-9.706 0h9.706m0 0H25.4m0 0a10.31 10.31 0 0 1 1.128-2.825c1.933-3.348 5.244-5.055 7.397-3.812 1.797 1.037 2.217 3.804 1.182 6.637m-9.707 0h9.707M10 26.043a2 2 0 0 1 2-2h24a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2v-13Z"
  }));
}

var IconGift = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconGiftComponent);
IconGift.defaultProps = {
  isIcon: true
};
IconGift.displayName = 'IconGift';
/* harmony default export */ __webpack_exports__["Z"] = (IconGift);

/***/ }),

/***/ 86776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconInfoCircleComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-info-circle")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    d: "M24 20v14m0-16v-4m18 10c0 9.941-8.059 18-18 18S6 33.941 6 24 14.059 6 24 6s18 8.059 18 18Z"
  }));
}

var IconInfoCircle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconInfoCircleComponent);
IconInfoCircle.defaultProps = {
  isIcon: true
};
IconInfoCircle.displayName = 'IconInfoCircle';
/* harmony default export */ __webpack_exports__["Z"] = (IconInfoCircle);

/***/ }),

/***/ 72297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconLinkComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-link")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    d: "m14.1 25.414-4.95 4.95a6 6 0 0 0 8.486 8.485l8.485-8.485a6 6 0 0 0 0-8.485m7.779.707 4.95-4.95a6 6 0 1 0-8.486-8.485l-8.485 8.485a6 6 0 0 0 0 8.485"
  }));
}

var IconLink = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconLinkComponent);
IconLink.defaultProps = {
  isIcon: true
};
IconLink.displayName = 'IconLink';
/* harmony default export */ __webpack_exports__["Z"] = (IconLink);

/***/ }),

/***/ 73153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconMoreVerticalComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-more-vertical")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M25 10h-2V8h2v2ZM25 25h-2v-2h2v2ZM25 40h-2v-2h2v2Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    d: "M25 10h-2V8h2v2ZM25 25h-2v-2h2v2ZM25 40h-2v-2h2v2Z"
  }));
}

var IconMoreVertical = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconMoreVerticalComponent);
IconMoreVertical.defaultProps = {
  isIcon: true
};
IconMoreVertical.displayName = 'IconMoreVertical';
/* harmony default export */ __webpack_exports__["Z"] = (IconMoreVertical);

/***/ }),

/***/ 85777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconUnorderedListComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-unordered-list")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    d: "M13 24h30M5 11h4m4 26h30M13 11h30M5 24h4M5 37h4"
  }));
}

var IconUnorderedList = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconUnorderedListComponent);
IconUnorderedList.defaultProps = {
  isIcon: true
};
IconUnorderedList.displayName = 'IconUnorderedList';
/* harmony default export */ __webpack_exports__["Z"] = (IconUnorderedList);

/***/ }),

/***/ 42617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LE": function() { return /* binding */ LiveRegion; },
/* harmony export */   "Mv": function() { return /* binding */ HiddenText; },
/* harmony export */   "qg": function() { return /* binding */ useAnnouncement; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


const hiddenStyles = {
  display: 'none'
};
function HiddenText(_ref) {
  let {
    id,
    value
  } = _ref;
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    id: id,
    style: hiddenStyles
  }, value);
}

function LiveRegion(_ref) {
  let {
    id,
    announcement,
    ariaLiveType = "assertive"
  } = _ref;
  // Hide element visually but keep it readable by screen readers
  const visuallyHidden = {
    position: 'fixed',
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(100%)',
    whiteSpace: 'nowrap'
  };
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    id: id,
    style: visuallyHidden,
    role: "status",
    "aria-live": ariaLiveType,
    "aria-atomic": true
  }, announcement);
}

function useAnnouncement() {
  const [announcement, setAnnouncement] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)('');
  const announce = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(value => {
    if (value != null) {
      setAnnouncement(value);
    }
  }, []);
  return {
    announce,
    announcement
  };
}


//# sourceMappingURL=accessibility.esm.js.map


/***/ }),

/***/ 10248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_useKeyPress; }
});

// EXTERNAL MODULE: ./node_modules/ahooks/es/useLatest/index.js
var useLatest = __webpack_require__(3930);
// EXTERNAL MODULE: ./node_modules/ahooks/es/utils/index.js
var utils = __webpack_require__(92770);
// EXTERNAL MODULE: ./node_modules/ahooks/es/utils/domTarget.js
var domTarget = __webpack_require__(48002);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/ahooks/es/utils/useEffectWithTarget.js
var useEffectWithTarget = __webpack_require__(59682);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/utils/useDeepCompareWithTarget.js



var depsEqual = function depsEqual(aDeps, bDeps) {
  if (bDeps === void 0) {
    bDeps = [];
  }
  return isEqual_default()(aDeps, bDeps);
};
var useDeepCompareEffectWithTarget = function useDeepCompareEffectWithTarget(effect, deps, target) {
  var ref = (0,react.useRef)();
  var signalRef = (0,react.useRef)(0);
  if (!depsEqual(deps, ref.current)) {
    ref.current = deps;
    signalRef.current += 1;
  }
  (0,useEffectWithTarget/* default */.Z)(effect, [signalRef.current], target);
};
/* harmony default export */ var useDeepCompareWithTarget = (useDeepCompareEffectWithTarget);
;// CONCATENATED MODULE: ./node_modules/ahooks/es/useKeyPress/index.js
var __values = undefined && undefined.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};




// 键盘事件 keyCode 别名
var aliasKeyCodeMap = {
  '0': 48,
  '1': 49,
  '2': 50,
  '3': 51,
  '4': 52,
  '5': 53,
  '6': 54,
  '7': 55,
  '8': 56,
  '9': 57,
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  ctrl: 17,
  alt: 18,
  pausebreak: 19,
  capslock: 20,
  esc: 27,
  space: 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  leftarrow: 37,
  uparrow: 38,
  rightarrow: 39,
  downarrow: 40,
  insert: 45,
  "delete": 46,
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  leftwindowkey: 91,
  rightwindowkey: 92,
  selectkey: 93,
  numpad0: 96,
  numpad1: 97,
  numpad2: 98,
  numpad3: 99,
  numpad4: 100,
  numpad5: 101,
  numpad6: 102,
  numpad7: 103,
  numpad8: 104,
  numpad9: 105,
  multiply: 106,
  add: 107,
  subtract: 109,
  decimalpoint: 110,
  divide: 111,
  f1: 112,
  f2: 113,
  f3: 114,
  f4: 115,
  f5: 116,
  f6: 117,
  f7: 118,
  f8: 119,
  f9: 120,
  f10: 121,
  f11: 122,
  f12: 123,
  numlock: 144,
  scrolllock: 145,
  semicolon: 186,
  equalsign: 187,
  comma: 188,
  dash: 189,
  period: 190,
  forwardslash: 191,
  graveaccent: 192,
  openbracket: 219,
  backslash: 220,
  closebracket: 221,
  singlequote: 222
};
// 修饰键
var modifierKey = {
  ctrl: function ctrl(event) {
    return event.ctrlKey;
  },
  shift: function shift(event) {
    return event.shiftKey;
  },
  alt: function alt(event) {
    return event.altKey;
  },
  meta: function meta(event) {
    return event.metaKey;
  }
};
// 根据 event 计算激活键数量
function countKeyByEvent(event) {
  var countOfModifier = Object.keys(modifierKey).reduce(function (total, key) {
    if (modifierKey[key](event)) {
      return total + 1;
    }
    return total;
  }, 0);
  // 16 17 18 91 92 是修饰键的 keyCode，如果 keyCode 是修饰键，那么激活数量就是修饰键的数量，如果不是，那么就需要 +1
  return [16, 17, 18, 91, 92].includes(event.keyCode) ? countOfModifier : countOfModifier + 1;
}
/**
 * 判断按键是否激活
 * @param [event: KeyboardEvent]键盘事件
 * @param [keyFilter: any] 当前键
 * @returns Boolean
 */
function genFilterKey(event, keyFilter, exactMatch) {
  var e_1, _a;
  // 浏览器自动补全 input 的时候，会触发 keyDown、keyUp 事件，但此时 event.key 等为空
  if (!event.key) {
    return false;
  }
  // 数字类型直接匹配事件的 keyCode
  if ((0,utils/* isNumber */.hj)(keyFilter)) {
    return event.keyCode === keyFilter;
  }
  // 字符串依次判断是否有组合键
  var genArr = keyFilter.split('.');
  var genLen = 0;
  try {
    for (var genArr_1 = __values(genArr), genArr_1_1 = genArr_1.next(); !genArr_1_1.done; genArr_1_1 = genArr_1.next()) {
      var key = genArr_1_1.value;
      // 组合键
      var genModifier = modifierKey[key];
      // keyCode 别名
      var aliasKeyCode = aliasKeyCodeMap[key.toLowerCase()];
      if (genModifier && genModifier(event) || aliasKeyCode && aliasKeyCode === event.keyCode) {
        genLen++;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (genArr_1_1 && !genArr_1_1.done && (_a = genArr_1["return"])) _a.call(genArr_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  /**
   * 需要判断触发的键位和监听的键位完全一致，判断方法就是触发的键位里有且等于监听的键位
   * genLen === genArr.length 能判断出来触发的键位里有监听的键位
   * countKeyByEvent(event) === genArr.length 判断出来触发的键位数量里有且等于监听的键位数量
   * 主要用来防止按组合键其子集也会触发的情况，例如监听 ctrl+a 会触发监听 ctrl 和 a 两个键的事件。
   */
  if (exactMatch) {
    return genLen === genArr.length && countKeyByEvent(event) === genArr.length;
  }
  return genLen === genArr.length;
}
/**
 * 键盘输入预处理方法
 * @param [keyFilter: any] 当前键
 * @returns () => Boolean
 */
function genKeyFormatter(keyFilter, exactMatch) {
  if ((0,utils/* isFunction */.mf)(keyFilter)) {
    return keyFilter;
  }
  if ((0,utils/* isString */.HD)(keyFilter) || (0,utils/* isNumber */.hj)(keyFilter)) {
    return function (event) {
      return genFilterKey(event, keyFilter, exactMatch);
    };
  }
  if (Array.isArray(keyFilter)) {
    return function (event) {
      return keyFilter.some(function (item) {
        return genFilterKey(event, item, exactMatch);
      });
    };
  }
  return keyFilter ? function () {
    return true;
  } : function () {
    return false;
  };
}
var defaultEvents = ['keydown'];
function useKeyPress(keyFilter, eventHandler, option) {
  var _a = option || {},
    _b = _a.events,
    events = _b === void 0 ? defaultEvents : _b,
    target = _a.target,
    _c = _a.exactMatch,
    exactMatch = _c === void 0 ? false : _c;
  var eventHandlerRef = (0,useLatest/* default */.Z)(eventHandler);
  var keyFilterRef = (0,useLatest/* default */.Z)(keyFilter);
  useDeepCompareWithTarget(function () {
    var e_2, _a;
    var _b;
    var el = (0,domTarget/* getTargetElement */.n)(target, window);
    if (!el) {
      return;
    }
    var callbackHandler = function callbackHandler(event) {
      var _a;
      var genGuard = genKeyFormatter(keyFilterRef.current, exactMatch);
      if (genGuard(event)) {
        return (_a = eventHandlerRef.current) === null || _a === void 0 ? void 0 : _a.call(eventHandlerRef, event);
      }
    };
    try {
      for (var events_1 = __values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
        var eventName = events_1_1.value;
        (_b = el === null || el === void 0 ? void 0 : el.addEventListener) === null || _b === void 0 ? void 0 : _b.call(el, eventName, callbackHandler);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (events_1_1 && !events_1_1.done && (_a = events_1["return"])) _a.call(events_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
    return function () {
      var e_3, _a;
      var _b;
      try {
        for (var events_2 = __values(events), events_2_1 = events_2.next(); !events_2_1.done; events_2_1 = events_2.next()) {
          var eventName = events_2_1.value;
          (_b = el === null || el === void 0 ? void 0 : el.removeEventListener) === null || _b === void 0 ? void 0 : _b.call(el, eventName, callbackHandler);
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (events_2_1 && !events_2_1.done && (_a = events_2["return"])) _a.call(events_2);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
    };
  }, [events], target);
}
/* harmony default export */ var es_useKeyPress = (useKeyPress);

/***/ })

}]);